function initRolltopBackpackGenerator() {
  const root = document.getElementById("rolltop-backpack-generator");
  if (!root) return;

  const statusEl = document.getElementById("rb_status");
  const btn      = document.getElementById("rb_generate");
  const canvas   = document.getElementById("rb_canvas");
  const ctx      = canvas ? canvas.getContext("2d") : null;
  const $        = id => document.getElementById(id);

  function setStatus(t) { if (statusEl) statusEl.textContent = t || ""; }
  function num(id)      { const el = $(id); return el ? (parseFloat(el.value) || 0) : 0; }
  function clamp(v,a,b) { return Math.max(a, Math.min(b, v)); }
  function mm(n)        { return Math.round(n * 100) / 100; }

  /* =========================
     LOGO
  ========================== */
  // The logo lives in assets/rb-logo.png, not inline. It is fetched once on init and
  // cached as a data URI, because jsPDF taints its internal canvas on cross-origin images.
  let LOGO_DATA_URI = null;

  function logoAssetUrl() {
    if (root.dataset && root.dataset.logoUrl) return root.dataset.logoUrl;
    // Fall back to deriving it from this script's own asset URL.
    const tag = document.querySelector('script[src*="Rolltop-backpack-generator"]');
    if (!tag) return null;
    return tag.src.replace(/Rolltop-backpack-generator\.js(\?.*)?$/, "rb-logo.png");
  }

  const logoReady = (function loadLogo() {
    const url = logoAssetUrl();
    if (!url) return Promise.resolve(null);
    return fetch(url, { mode: "cors" })
      .then(r => r.ok ? r.blob() : Promise.reject(new Error("logo " + r.status)))
      .then(blob => new Promise((res, rej) => {
        const fr = new FileReader();
        fr.onload  = () => res(fr.result);
        fr.onerror = rej;
        fr.readAsDataURL(blob);
      }))
      .then(uri => { LOGO_DATA_URI = uri; return uri; })
      .catch(() => null);   // PDF is still generated, just without the logo
  })();

  function pdfAddLogo(pdf, x, y, w, h) {
    if (!LOGO_DATA_URI) return;
    try { pdf.addImage(LOGO_DATA_URI, "PNG", x, y, w, h); } catch(e) {}
  }

  /* =========================
     Materials
  ========================== */
  const MATERIALS = {
    "Sun Yellow":         { base: "#FFE33C" },
    "Friluftstyger Green":{ base: "#2C5F2D" },
    "Charcoal":           { base: "#2A2A2A" },
    "Ocean Blue":         { base: "#1F4E79" },
    "Clay Orange":        { base: "#B85C2B" },
    "Light Grey":         { base: "#D9D9D9" }
  };

  // House standard. Not user-selectable: the fold edge is exempt from the
  // allowance, and letting people change the value invites cutting that wrong.
  const SEAM_ALLOWANCE = 10;   // mm, added outside every finished line
  const MESH_CASING    = 20;   // mm, elastic casing at the mesh top edge
  const ROLLTOP        = 150;  // mm added above the entered body height
  const BOTTOM_WRAP    = 50;   // mm the bottom panel turns up the front
  const COVER_H        = 80;   // mm finished height of the shoulder cover strip
  const SPLIT_FROM_TOP = 70;   // mm from the top of the torso to the shoulder line
  const BLADDER_H      = 300;  // mm inner divider pocket, bladder hangs from a loop
  const POCKET_VOLUME  = 80;   // mm extra side-pocket width, folded in at the base
  const CORD_CHANNEL   = 25;   // mm double hem at the side pocket top, holds the cord
  const ROLLTOP_STRAP  = 250;  // mm up the back edge, alternative rolltop anchor

  // Top Y-strap over the rolled closure. Fixed proportions of the bag, shared by
  // the 3D preview and the pattern so the two can never disagree.
  const YSTRAP = {
    anchorXFrac: 0.40,   // of the half width at the top, out from the centre
    anchorDrop:  0.14,   // of the height, below the top edge (back anchors)
    buckleDrop:  0.30,   // of the height, below the top edge (front buckle)
    webbing:     20      // mm
  };

  function ensureMaterialUI() {
    if ($("rb_mat")) return;
    const controls = root.querySelector(".rb-controls");
    const genBtn   = $("rb_generate");
    const wrap     = document.createElement("div");
    wrap.className = "rb-field";
    const label    = document.createElement("label");
    label.textContent = "Fabric material (preview)";
    label.setAttribute("for", "rb_mat");
    const sel = document.createElement("select");
    sel.id = "rb_mat";
    Object.keys(MATERIALS).forEach(name => {
      const opt = document.createElement("option");
      opt.value = name; opt.textContent = name;
      sel.appendChild(opt);
    });
    sel.value = "Sun Yellow";
    wrap.appendChild(label); wrap.appendChild(sel);
    if (controls && genBtn) controls.insertBefore(wrap, genBtn);
  }

  // Hardware inputs are injected here rather than in the Liquid section, so the
  // whole generator stays in one file.
  const HW_FIELDS = [
    ["rb_strap_gap", "Distance between the shoulder straps (mm)",         70, 55, 90,  1],
    ["rb_angle",     "Shoulder angle (degrees from horizontal)",          20,  0,  35,  1],
    ["rb_strap_w",   "Shoulder strap width (mm)",                        40,  20, 60,  5],
    ["rb_comp1",     "Side compression 1 \u2014 from bottom (mm)",        250, 40, 900, 10],
    ["rb_comp2",     "Side compression 2 \u2014 from bottom (mm)",        380, 40, 900, 10]
  ];

  // A small "How to measure" toggle under a field. Two of the inputs are body
  // measurements and people get them wrong in predictable ways.
  const HELP = {
    rb_torso: ["How to measure your torso",
      "Find the bony bump at the base of your neck — that is the C7 vertebra, the "
      + "one that sticks out when you tip your head forward. Measure straight down "
      + "the spine to the top of your hip bones, level with the belly button. "
      + "Get someone else to do it: reaching behind yourself tilts your back and "
      + "shortens the reading by a couple of centimetres. Most adults land between "
      + "400 and 550 mm. This sets where the shoulder straps attach, not how tall "
      + "the bag is."],
    rb_strap_gap: ["How to measure the strap spacing",
      "This is the gap between the two straps where they leave the back panel, "
      + "not your neck width. Measure across your upper back between the points "
      + "where the straps should sit, just inside the shoulder joints. Too narrow "
      + "and the webbing rubs your neck; too wide and the straps slide off your "
      + "shoulders. 55 to 90 mm covers most people — start at 70 mm."]
  };

  function addHelpTo(id) {
    const conf = HELP[id];
    const numEl = $(id);
    if (!conf || !numEl || $(id + "_help")) return;
    const field = numEl.closest(".rb-field") || numEl.parentElement;

    const link = document.createElement("button");
    link.type = "button"; link.id = id + "_helplink";
    link.textContent = "How to measure \u2192";
    link.style.cssText = "background:none;border:none;padding:4px 0 0 0;cursor:pointer;"
      + "font:inherit;font-size:12px;font-weight:700;color:#2C5F2D;text-decoration:underline";

    const panel = document.createElement("div");
    panel.id = id + "_help";
    panel.hidden = true;
    panel.style.cssText = "margin-top:6px;padding:10px 12px;border-radius:10px;"
      + "background:rgba(255,227,60,.18);border:1px solid rgba(0,0,0,.06);"
      + "font-size:12px;line-height:1.45;color:#3a3a3a";
    const h = document.createElement("strong");
    h.textContent = conf[0];
    h.style.cssText = "display:block;margin-bottom:4px;color:#2C5F2D";
    const b = document.createElement("span");
    b.textContent = conf[1];
    panel.appendChild(h); panel.appendChild(b);

    link.addEventListener("click", function () {
      panel.hidden = !panel.hidden;
      link.textContent = panel.hidden ? "How to measure \u2192" : "Hide \u2191";
    });
    field.appendChild(link);
    field.appendChild(panel);
  }

  function ensureHardwareUI() {
    if ($("rb_strap_w")) return;
    const controls = root.querySelector(".rb-controls");
    const genBtn   = $("rb_generate");
    if (!controls || !genBtn) return;

    const head = document.createElement("div");
    head.className = "rb-section-label";
    head.style.marginTop = "14px";
    head.textContent = "Hardware placement";
    controls.insertBefore(head, genBtn);

    HW_FIELDS.forEach(function (f) {
      const wrap = document.createElement("div");
      wrap.className = "rb-field";
      const label = document.createElement("label");
      label.textContent = f[1];
      label.setAttribute("for", f[0]);
      const inp = document.createElement("input");
      inp.type = "number"; inp.id = f[0];
      inp.value = String(f[2]); inp.min = String(f[3]);
      inp.max = String(f[4]);   inp.step = String(f[5]);
      wrap.appendChild(label); wrap.appendChild(inp);
      controls.insertBefore(wrap, genBtn);

      // Give the field a slider and redraw as it moves. Wiring this here rather
      // than in the init list means an injected field can never be created
      // without its slider and its listener.
      addRangeTo(f[0], { min: f[3], max: f[4], step: f[5] });
      inp.addEventListener("input",  requestDraw);
      inp.addEventListener("change", requestDraw);
      addHelpTo(f[0]);
    });
  }

  function getMaterial() {
    const sel = $("rb_mat");
    return MATERIALS[sel?.value] || MATERIALS["Sun Yellow"];
  }

  /* =========================
     Range sliders
  ========================== */
  function addRangeTo(id, { min, max, step }) {
    const numEl = $(id);
    if (!numEl || $(id + "_range")) return;
    if (min  != null) numEl.min  = String(min);
    if (max  != null) numEl.max  = String(max);
    if (step != null) numEl.step = String(step);
    const row = document.createElement("div");
    row.style.cssText = "display:grid;grid-template-columns:1fr 110px;gap:10px;align-items:center";
    const range = document.createElement("input");
    range.type = "range"; range.id = id + "_range";
    range.min = String(min ?? 0); range.max = String(max ?? 100);
    range.step = String(step ?? 1); range.value = numEl.value || "0";
    range.style.accentColor = "#FFE33C";
    const parent = numEl.parentElement;
    parent.insertBefore(row, numEl);
    row.appendChild(range); row.appendChild(numEl);
    range.addEventListener("input", () => { numEl.value = range.value; numEl.dispatchEvent(new Event("input", { bubbles: true })); });
    numEl.addEventListener("input", () => { range.value = numEl.value || "0"; });
  }

  function setupRanges() {
    addRangeTo("rb_wt", { min: 100, max: 600, step: 5 });
    addRangeTo("rb_wb", { min:  80, max: 600, step: 5 });
    addRangeTo("rb_h",  { min: 150, max: 1100, step: 5 });
    addRangeTo("rb_d",  { min:  50, max: 400, step: 5 });
    addRangeTo("rb_fp", { min:  50, max: 400, step: 5 });
    addRangeTo("rb_sp_front", { min: 50, max: 350, step: 5 });
    addRangeTo("rb_torso",         { min: 300, max: 600, step: 5 });

  }

  /* =========================
     Reset view
  ========================== */
  const heroCam = { rx: 0.42, ry: 0.55, zoom: 0.72, cx: 400, cy: 420 };

  // Canvas is sized to its CSS box and scaled by devicePixelRatio so it stays crisp.
  let CW = 800, CH = 800;
  function resizeCanvas() {
    if (!canvas || !ctx) return;
    const dpr  = Math.min(window.devicePixelRatio || 1, 2);
    const rect = canvas.getBoundingClientRect();
    CW = Math.max(320, Math.round(rect.width || 800));
    CH = CW;
    canvas.width  = Math.round(CW * dpr);
    canvas.height = Math.round(CH * dpr);
    canvas.style.height = CH + "px";
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    heroCam.cx = CW / 2;
    heroCam.cy = CH * 0.525;
  }

  let rafPending = false;
  function requestDraw() {
    if (rafPending) return;
    rafPending = true;
    requestAnimationFrame(() => { rafPending = false; drawPreview(); });
  }

  function ensureResetViewButton() {
    if ($("rb_resetView")) return;
    const b = document.createElement("button");
    b.id = "rb_resetView"; b.type = "button"; b.textContent = "Reset view";
    b.style.cssText = "width:100%;margin-top:10px;padding:14px;border-radius:14px;border:1px solid rgba(0,0,0,0.12);background:#fff;font-weight:900;cursor:pointer;box-shadow:0 10px 18px rgba(0,0,0,0.06)";
    const controls = root.querySelector(".rb-controls");
    const genBtn   = $("rb_generate");
    if (controls && genBtn) controls.insertBefore(b, genBtn);
    b.addEventListener("click", () => {
      heroCam.rx = 0.42; heroCam.ry = 0.55; heroCam.zoom = 0.72;
      heroCam.cx = CW/2; heroCam.cy = CH*0.525;
      drawPreview();
    });
  }

  /* =========================
     Params
  ========================== */
  function getParams() {
    return {
      Wt:   num("rb_wt"),   // width top
      Wb:   num("rb_wb"),   // width bottom
      H:    num("rb_h"),    // front height
      D:    num("rb_d"),    // depth
      FP:   num("rb_fp"),   // front pocket height
      Torso: num("rb_torso") || num("rb_h"), // back panel height (torso length)
      SPfront: num("rb_sp_front"), // front edge height (slider)
      SPback:  120,               // back edge height (fixed, toward back panel)
      RT:      120,               // rolltop allowance: 2 folds x 60 mm (matches the fold lines in the 3D view)
      StrapGap:      num("rb_strap_gap") || 70,  // inner edge to inner edge of the straps
      ShoulderAngle: num("rb_angle") || 20,   // degrees from horizontal
      StrapW:   num("rb_strap_w")   || 40,   // webbing width
      Comp1:    num("rb_comp1")     || 250,  // side compression 1, from panel bottom
      Comp2:    num("rb_comp2")     || 380,  // side compression 2, from panel bottom
      Seam: SEAM_ALLOWANCE
    };
  }

  /* =========================
     Piece geometry
  ========================== */
  // Entered dimensions are the FINISHED bag. Seam allowance is added outside the
  // finished line, so the cut piece is always larger. On a slanted edge the
  // allowance is measured perpendicular to the edge, which makes the horizontal
  // offset slightly larger than the seam value.
  function outsetTrap(wTop, wBot, h, s) {
    const m  = (wTop - wBot) / (2 * h);       // half-width gradient
    const dx = s * Math.sqrt(1 + m * m);      // perpendicular allowance, measured horizontally
    return { wTop: wTop + 2 * (dx + m * s), wBot: wBot + 2 * (dx - m * s), h: h + 2 * s };
  }
  function outsetRect(w, h, s) { return { w: w + 2 * s, h: h + 2 * s }; }

  function computePieces(p) {
    const SA = p.Seam;

    // The entered height is the body. The roll is added on top, and the bottom
    // panel turns up the front, so the front panel is shorter than the back.
    const totalH = p.H + ROLLTOP;

    // Half width of the bag at a height above the finished bottom.
    const kW = (p.Wt - p.Wb) / (2 * totalH);
    const cW = p.Wb / 2;
    const halfAt = (y) => cW + kW * y;
    const fullAt = (y) => 2 * halfAt(y);

    // --- main panels -------------------------------------------------------
    const front = { wTop: p.Wt, wBot: fullAt(BOTTOM_WRAP), h: totalH - BOTTOM_WRAP };
    const back  = { wTop: p.Wt, wBot: p.Wb,                h: totalH };
    const side  = { w: p.D,     h: totalH };
    const bottom = { w: p.Wb,   h: p.D + BOTTOM_WRAP, wrap: BOTTOM_WRAP };

    // --- shoulder line and cover strip -------------------------------------
    // Flat across the neck, then falling away at the shoulder angle.
    // The flat section of the shoulder line is exactly the gap between the
    // straps: they attach at its two ends, where the line starts to fall away.
    const neckHalf   = p.StrapGap / 2;
    const tanA       = Math.tan(p.ShoulderAngle * Math.PI / 180);
    const splitCentreFromBot = p.Torso - SPLIT_FROM_TOP;
    const lineYAt = (dist) =>
      dist <= neckHalf ? splitCentreFromBot
                       : splitCentreFromBot - tanA * (dist - neckHalf);

    // Where the shoulder line meets the side edge of the back panel. Solved
    // directly: the line and the panel edge are both linear in the distance.
    const dEdge = (cW + kW * splitCentreFromBot + kW * tanA * neckHalf) / (1 + kW * tanA);
    const splitEdgeFromBot = lineYAt(dEdge);

    // Cover strip: top edge follows the shoulder line, bottom edge is STRAIGHT,
    // sides follow the back panel edge. So the strip is tallest at the centre
    // and narrows towards the edges as the shoulder line falls away.
    const coverBotFromBot = splitCentreFromBot - COVER_H;
    const coverEdgeH      = splitEdgeFromBot - coverBotFromBot;   // height at the side edge
    const backCover = {
      tooNarrow: coverEdgeH < 15, // the angle has eaten the strip at the edge
      h: COVER_H,                 // height at the centre
      edgeH: coverEdgeH,          // height where it meets the panel edge
      botFromBot: coverBotFromBot,
      neckHalf, tanA,
      centreFromBot: splitCentreFromBot,
      edgeFromBot:   splitEdgeFromBot,
      halfWidth:     dEdge,
      lineYAt
    };

    // --- pockets -----------------------------------------------------------
    // Front mesh sits flat on the panel: no volume fold, own material.
    const frontMesh = {
      wBot: fullAt(BOTTOM_WRAP),
      wTop: fullAt(BOTTOM_WRAP + p.FP),
      h: p.FP, casingH: MESH_CASING
    };

    // Side pocket: extra width folded in at the base for volume, angled top.
    const sidePocket = {
      w: p.D + POCKET_VOLUME, volume: POCKET_VOLUME,
      hFront: p.SPfront, hBack: p.SPback
    };

    // Inner divider pocket. A 3 L bladder is ~410 mm tall, so it hangs from a
    // loop at the top rather than standing in the pocket.
    const innerPocket = { wBot: p.Wb, wTop: fullAt(BLADDER_H), h: BLADDER_H, hangLoop: true };

    // --- cut geometry ------------------------------------------------------
    front.cut       = outsetTrap(front.wTop, front.wBot, front.h, SA);
    back.cut        = outsetTrap(back.wTop,  back.wBot,  back.h,  SA);
    bottom.cut      = outsetRect(bottom.w,   bottom.h,   SA);
    side.cut        = outsetRect(side.w,     side.h,     SA);
    backCover.cut   = { h: COVER_H + 2 * SA, edgeH: coverEdgeH + 2 * SA,
                        halfWidth: dEdge + SA };
    frontMesh.cut   = outsetTrap(frontMesh.wTop, frontMesh.wBot, frontMesh.h + MESH_CASING, SA);
    // The pocket top is a double hem holding the chock cord, not a seam.
    sidePocket.channel = CORD_CHANNEL;
    sidePocket.cut  = { w: sidePocket.w + 2 * SA,
                        h: Math.max(p.SPfront, p.SPback) + SA + 2 * CORD_CHANNEL };
    innerPocket.cut = outsetTrap(innerPocket.wTop, innerPocket.wBot, innerPocket.h, SA);

    // Kept for callers that still expect the old names.
    const backLower = back;

    return { front, back, backLower, backCover, bottom, side,
             frontMesh, sidePocket, innerPocket, totalH, halfAt, fullAt };
  }

  /* =========================
     3D helpers
  ========================== */
  function hexToRgb(hex) {
    const h = hex.replace("#","").trim();
    const v = h.length===3 ? h.split("").map(c=>c+c).join("") : h;
    const n = parseInt(v,16);
    return { r:(n>>16)&255, g:(n>>8)&255, b:n&255 };
  }

  function shade(hex, amt) {
    const c = hexToRgb(hex);
    const t = amt>=0 ? 255 : 0;
    const p = Math.abs(amt);
    return `rgb(${Math.round((t-c.r)*p+c.r)},${Math.round((t-c.g)*p+c.g)},${Math.round((t-c.b)*p+c.b)})`;
  }

  function proj3D(pt, cam) {
    const { rx, ry, zoom, cx, cy } = cam;
    const [x0,y0,z0] = pt;
    const cyy=Math.cos(ry), syy=Math.sin(ry);
    const cxx=Math.cos(rx), sxx=Math.sin(rx);
    let x1 = x0*cyy - z0*syy;
    let z1 = x0*syy + z0*cyy;
    let y1 = y0*cxx - z1*sxx;
    let z2 = y0*sxx + z1*cxx;
    const dist=900, s=(dist/(dist-z2))*zoom;
    return { x: cx+x1*s, y: cy-y1*s, z: z2 };
  }

  // Rotates a normal with the camera. z > 0 means the face points at the viewer.
  function facing(normal, cam) {
    const { rx, ry } = cam;
    const [x0, y0, z0] = normal;
    const z1 = x0 * Math.sin(ry) + z0 * Math.cos(ry);
    return (y0 * Math.sin(rx) + z1 * Math.cos(rx)) > 0;
  }

  function drawFace(ctx2, pts, fill, stroke="rgba(0,0,0,0.30)", lw=1.0) {
    ctx2.beginPath();
    ctx2.moveTo(pts[0].x, pts[0].y);
    for (let i=1;i<pts.length;i++) ctx2.lineTo(pts[i].x,pts[i].y);
    ctx2.closePath();
    ctx2.fillStyle=fill; ctx2.fill();
    ctx2.strokeStyle=stroke; ctx2.lineWidth=lw; ctx2.stroke();
  }

  function fitScale(Wt, H, D, maxPx=480) {
    return maxPx / Math.max(Wt, H, D, 1);
  }

  /* =========================
     Draw trapezoid prism
     (front/back = trapezoid, sides = rect, top/bottom = rect)
  ========================== */
  function drawBackpack3D(ctx2, cam, p, s, base) {
    const wt = p.Wt * s;
    const wb = p.Wb * s;
    // The view shows the bag closed, so the roll is folded away and the body is
    // the entered height. The pattern is ROLLTOP taller for that reason.
    const h  = p.H  * s;
    const d  = p.D  * s;

    const hw_t = wt/2, hw_b = wb/2;
    const hh   = h/2,  hd = d/2;

    // 8 corners of the trapezoid prism (main body)
    const FL = [-hw_b, -hh,  hd];
    const FR = [ hw_b, -hh,  hd];
    const FTR= [ hw_t,  hh,  hd];
    const FTL= [-hw_t,  hh,  hd];
    const BL = [-hw_b, -hh, -hd];
    const BR = [ hw_b, -hh, -hd];
    const BTR= [ hw_t,  hh, -hd];
    const BTL= [-hw_t,  hh, -hd];

    function p3(pt) { return proj3D(pt, cam); }

    // Which sides face the viewer? Details are only drawn on those.
    const seeFront = facing([ 0,0, 1], cam);
    const seeBack  = facing([ 0,0,-1], cam);
    const seeLeft  = facing([-1,0, 0], cam);
    const seeRight = facing([ 1,0, 0], cam);

    const faces = [];

    // Back face
    faces.push({ pts:[BL,BR,BTR,BTL].map(p3), fill: shade(base,-0.18), z: -hd });
    // Bottom
    faces.push({ pts:[BL,BR,FR,FL].map(p3),   fill: shade(base,-0.22), z: -hh });
    // Left side (trapezoid)
    faces.push({ pts:[BL,FL,FTL,BTL].map(p3), fill: shade(base,-0.10), z: 0 });
    // Right side (trapezoid)
    faces.push({ pts:[BR,FR,FTR,BTR].map(p3), fill: shade(base,-0.06), z: 0 });
    // Top (trapezoid top edge)
    faces.push({ pts:[BTL,FTL,FTR,BTR].map(p3), fill: shade(base, 0.12), z: hh });
    // Front face
    faces.push({ pts:[FL,FR,FTR,FTL].map(p3), fill: shade(base, 0.06), z: hd });

    // Sort by average Z and draw back-to-front
    faces
      .map(f => ({ ...f, avgZ: f.pts.reduce((a,pt)=>a+pt.z,0)/f.pts.length }))  /* recompute in screen space */
      .sort((a,b) => a.avgZ - b.avgZ)
      .forEach(f => drawFace(ctx2, f.pts, f.fill));

    // Helper: interpolated half-width at a given y in 3D space (-hh=bottom, +hh=top)
    function xAtY(y) { const t = (y - (-hh)) / (hh - (-hh)); return hw_b + (hw_t - hw_b) * t; }

    // Front pocket — filled darker panel, follows trapezoid taper
    const fpH   = p.FP * s;
    const fpBot = -hh;
    const fpTop = fpBot + fpH;
    const fpPts = [
      [-xAtY(fpBot), fpBot,  hd+0.5],
      [ xAtY(fpBot), fpBot,  hd+0.5],
      [ xAtY(fpTop), fpTop,  hd+0.5],
      [-xAtY(fpTop), fpTop,  hd+0.5]
    ].map(p3);
    if (seeFront) {
    ctx2.save();
    ctx2.beginPath();
    ctx2.moveTo(fpPts[0].x, fpPts[0].y);
    fpPts.forEach(pt => ctx2.lineTo(pt.x, pt.y));
    ctx2.closePath();
    ctx2.fillStyle = shade(base, -0.28);
    ctx2.fill();
    ctx2.strokeStyle = "rgba(0,0,0,0.45)";
    ctx2.setLineDash([]);
    ctx2.lineWidth = 1.2;
    ctx2.stroke();
    ctx2.restore();
    }

    // Side pockets — filled darker panels, x follows trapezoid taper at each height
    const spHF = p.SPfront * s;
    const spHB = p.SPback  * s;
    [ -1, 1 ].forEach(sign => {
      if (sign < 0 ? !seeLeft : !seeRight) return;
      const yBot   = -hh;
      const yFront = yBot + spHF;  // top-front (tall edge, z=+hd)
      const yBack  = yBot + spHB;  // top-back  (short edge, z=-hd)
      const xBot   = xAtY(yBot);
      const xFront = xAtY(yFront);
      const xBack  = xAtY(yBack);
      const spPts = [
        [sign*xBot,   yBot,    hd+0.3],
        [sign*xFront, yFront,  hd+0.3],
        [sign*xBack,  yBack,  -hd-0.3],
        [sign*xBot,   yBot,   -hd-0.3],
      ].map(p3);
      ctx2.save();
      ctx2.beginPath();
      ctx2.moveTo(spPts[0].x, spPts[0].y);
      spPts.forEach(pt => ctx2.lineTo(pt.x, pt.y));
      ctx2.closePath();
      ctx2.fillStyle = shade(base, sign < 0 ? -0.32 : -0.28);
      ctx2.fill();
      ctx2.strokeStyle = "rgba(0,0,0,0.40)";
      ctx2.setLineDash([]);
      ctx2.lineWidth = 1.1;
      ctx2.stroke();
      ctx2.restore();
    });

    // Shoulder strap split line on back face — saddle shape (__/---\__)
    if (seeBack) {
      // Same construction as computePieces: flat across the neck, then falling
      // at the shoulder angle until it meets the panel edge.
      const splitCtr   = (p.Torso - SPLIT_FROM_TOP) * s;
      const flatHalf   = (p.StrapGap / 2) * s;
      const tanA       = Math.tan(p.ShoulderAngle * Math.PI / 180);
      const kW         = (hw_t - hw_b) / (2 * hh);
      const dEdge      = (hw_b + kW * splitCtr + kW * tanA * flatHalf) / (1 + kW * tanA);
      const splitEdge  = splitCtr - tanA * Math.max(0, dEdge - flatHalf);
      // The back panel shares its bottom edge with the body, so measure from -hh.
      const yBot  = -hh;
      const yCtr  = yBot + splitCtr;  // y at centre of split (highest)
      const yEdge = yBot + splitEdge; // y at side edges (lower)
      // x coords: left edge x=-hw_b, right edge x=+hw_b (bottom width)
      // Split line: left edge → angled up to -flatHalf → flat to +flatHalf → angled down to right edge
      const splitPts = [
        [-dEdge, yEdge, -hd-0.5],
        [-flatHalf, yCtr, -hd-0.5],
        [ flatHalf, yCtr, -hd-0.5],
        [ dEdge, yEdge, -hd-0.5],
      ].map(p3);
      ctx2.save();
      ctx2.strokeStyle = "rgba(255,255,255,0.75)";
      ctx2.setLineDash([5,4]);
      ctx2.lineWidth = 1.8;
      ctx2.beginPath();
      ctx2.moveTo(splitPts[0].x, splitPts[0].y);
      splitPts.forEach(pt => ctx2.lineTo(pt.x, pt.y));
      ctx2.stroke();
      ctx2.restore();
    }

    // Side compression straps — two per side, drawn as webbing bands wrapping
    // the side face. Replaces the rolltop fold lines, which said nothing useful
    // in 3D.
    const WEBBING_MM = 20;
    const compFromBot = [
      Math.max(20, Math.min(p.H - 20, p.Comp1)),
      Math.max(20, Math.min(p.H - 20, p.Comp2))
    ];
    compFromBot.forEach(distMM => {
      const yMid = -hh + distMM * s;
      const half = (WEBBING_MM * s) / 2;
      const yTop = Math.min(hh, yMid + half);
      const yBot = Math.max(-hh, yMid - half);
      if (yTop <= yBot) return;

      [ -1, 1 ].forEach(sign => {
        if (sign < 0 ? !seeLeft : !seeRight) return;
        const xT = xAtY(yTop), xB = xAtY(yBot);
        const band = [
          [sign*xB, yBot,  hd+0.4],
          [sign*xT, yTop,  hd+0.4],
          [sign*xT, yTop, -hd-0.4],
          [sign*xB, yBot, -hd-0.4]
        ].map(p3);
        ctx2.save();
        ctx2.beginPath();
        ctx2.moveTo(band[0].x, band[0].y);
        band.forEach(pt => ctx2.lineTo(pt.x, pt.y));
        ctx2.closePath();
        ctx2.fillStyle = "rgba(30,30,30,0.78)";
        ctx2.fill();
        ctx2.strokeStyle = "rgba(0,0,0,0.5)";
        ctx2.setLineDash([]);
        ctx2.lineWidth = 0.9;
        ctx2.stroke();

        // Buckle: a small block on the front half of the band.
        const bx = xAtY(yMid), bz = hd * 0.45;
        const bHalf = half * 0.85, bLen = hd * 0.30;
        const buckle = [
          [sign*bx, yMid - bHalf, bz + bLen],
          [sign*bx, yMid + bHalf, bz + bLen],
          [sign*bx, yMid + bHalf, bz - bLen],
          [sign*bx, yMid - bHalf, bz - bLen]
        ].map(p3);
        ctx2.beginPath();
        ctx2.moveTo(buckle[0].x, buckle[0].y);
        buckle.forEach(pt => ctx2.lineTo(pt.x, pt.y));
        ctx2.closePath();
        ctx2.fillStyle = "rgba(215,215,215,0.95)";
        ctx2.fill();
        ctx2.strokeStyle = "rgba(0,0,0,0.55)";
        ctx2.lineWidth = 0.8;
        ctx2.stroke();
        ctx2.restore();
      });
    });

    // Rolltop compression straps — one up each side face, from the anchor at the
    // bottom seam over the closed roll. Drawn where the pattern marks them.
    {
      const bandW = 20 * s;
      [ -1, 1 ].forEach(sign => {
        if (sign < 0 ? !seeLeft : !seeRight) return;
        const zHalf = bandW / 2;
        const yTop = hh, yBot = -hh;
        const xT = xAtY(yTop), xB = xAtY(yBot);
        const band = [
          [sign*xB, yBot, -zHalf],
          [sign*xT, yTop, -zHalf],
          [sign*xT, yTop,  zHalf],
          [sign*xB, yBot,  zHalf]
        ].map(p3);
        ctx2.save();
        ctx2.setLineDash([]);
        ctx2.beginPath();
        ctx2.moveTo(band[0].x, band[0].y);
        band.forEach(pt => ctx2.lineTo(pt.x, pt.y));
        ctx2.closePath();
        ctx2.fillStyle = "rgba(40,40,40,0.72)";
        ctx2.fill();
        ctx2.strokeStyle = "rgba(0,0,0,0.45)";
        ctx2.lineWidth = 0.8;
        ctx2.stroke();

        // Buckle near the top, where it tensions against the roll.
        // High on the panel, well clear of the upper compression buckle — this is
        // the strap that tensions against the rolled top.
        const yBk = hh - 22 * s, xBk = xAtY(yBk);
        const bk = [
          [sign*xBk, yBk - zHalf*1.1, -zHalf*1.7],
          [sign*xBk, yBk + zHalf*1.1, -zHalf*1.7],
          [sign*xBk, yBk + zHalf*1.1,  zHalf*1.7],
          [sign*xBk, yBk - zHalf*1.1,  zHalf*1.7]
        ].map(p3);
        ctx2.beginPath();
        ctx2.moveTo(bk[0].x, bk[0].y);
        bk.forEach(pt => ctx2.lineTo(pt.x, pt.y));
        ctx2.closePath();
        ctx2.fillStyle = "rgba(220,220,220,0.95)";
        ctx2.fill();
        ctx2.strokeStyle = "rgba(0,0,0,0.5)";
        ctx2.lineWidth = 0.7;
        ctx2.stroke();
        ctx2.restore();
      });
    }

    // Top Y-strap over the closed rolltop. Fixed geometry, not user-adjustable:
    // two anchors on the back panel, legs up over the top to a junction, then a
    // single leg down the front to a buckle.
    {
      const seeTop  = facing([0, 1, 0], cam);
      const H3      = hh * 2;
      const yAnc    = hh - H3 * YSTRAP.anchorDrop;
      const ax      = hw_t * YSTRAP.anchorXFrac;
      const axTop   = ax * 0.68;         // legs converge as they rise
      const jz      = hd * 0.35;         // junction on the top face
      const yF      = -hh + (p.FP + 40) * s;   // matches the pattern marking

      const wA = p3([0, hh, 0]), wB = p3([YSTRAP.webbing * s, hh, 0]);
      const lw = Math.max(2, Math.hypot(wB.x - wA.x, wB.y - wA.y));

      const AL = p3([-ax,    yAnc, -hd - 0.4]);
      const AR = p3([ ax,    yAnc, -hd - 0.4]);
      const TL = p3([-axTop, hh + 0.4, -hd]);
      const TR = p3([ axTop, hh + 0.4, -hd]);
      const J  = p3([0, hh + 0.4, jz]);
      const E  = p3([0, hh + 0.4, hd]);
      const F  = p3([0, yF, hd + 0.4]);

      function webLine(a, b) {
        ctx2.beginPath();
        ctx2.moveTo(a.x, a.y);
        ctx2.lineTo(b.x, b.y);
        ctx2.stroke();
      }

      ctx2.save();
      ctx2.setLineDash([]);
      ctx2.lineCap = "round";
      ctx2.lineJoin = "round";
      ctx2.strokeStyle = "rgba(30,30,30,0.82)";
      ctx2.lineWidth = lw;

      if (seeBack) { webLine(AL, TL); webLine(AR, TR); }
      if (seeTop)  { webLine(TL, J); webLine(TR, J); webLine(J, E); }
      if (seeFront) webLine(E, F);

      // Anchor tabs on the back panel.
      if (seeBack) {
        ctx2.fillStyle = "rgba(20,20,20,0.9)";
        [AL, AR].forEach(pt => {
          ctx2.beginPath();
          ctx2.arc(pt.x, pt.y, lw * 0.6, 0, Math.PI * 2);
          ctx2.fill();
        });
      }

      // Buckle at the front anchor.
      if (seeFront) {
        const bh = lw * 0.8, bw = lw * 1.6;
        ctx2.fillStyle = "rgba(215,215,215,0.95)";
        ctx2.strokeStyle = "rgba(0,0,0,0.55)";
        ctx2.lineWidth = Math.max(0.8, lw * 0.12);
        ctx2.beginPath();
        ctx2.rect(F.x - bw / 2, F.y - bh / 2, bw, bh);
        ctx2.fill();
        ctx2.stroke();
      }
      ctx2.restore();
    }
  }

  /* =========================
     3D Preview render
  ========================== */
  function warnIfCoverTooNarrow(p) {
    const el = $("rb_status");
    if (!el) return;
    let g;
    try { g = computePieces(p); } catch (e) { return; }
    if (g.backCover.tooNarrow) {
      el.textContent = "Shoulder angle too steep for this strap spacing — the cover "
        + "strip is only " + mm(g.backCover.edgeH) + " mm at the edge. Reduce the angle "
        + "or widen the spacing.";
      el.style.color = "#C02828";
    } else if (el.style.color === "rgb(192, 40, 40)") {
      el.textContent = ""; el.style.color = "";
    }
  }

  function drawPreview() {
    if (!ctx) return;
    const p   = getParams();
    const mat = getMaterial();
    const k   = CW / 800;
    warnIfCoverTooNarrow(p);
    const s   = fitScale(p.Wt, p.H, p.D, 460 * k);

    ctx.clearRect(0, 0, CW, CH);
    const bg = ctx.createLinearGradient(0,0,CW,CH);
    bg.addColorStop(0, "#F4F6F4"); bg.addColorStop(1, "#E8ECE8");
    ctx.fillStyle = bg; ctx.fillRect(0,0,CW,CH);

    ctx.fillStyle = "#2C5F2D"; ctx.font = "bold 18px Arial";
    ctx.fillText("Rolltop Backpack – 3D Preview", 22, 30);
    ctx.fillStyle = "rgba(0,0,0,0.55)"; ctx.font = "12px Arial";
    ctx.fillText(`Top ${Math.round(p.Wt)} · Bot ${Math.round(p.Wb)} · H ${Math.round(p.H)} · D ${Math.round(p.D)} mm`, 22, 50);
    ctx.fillText("Drag to rotate · scroll to zoom", 22, 68);

    // Shadow
    const shadowPt = proj3D([0, -(p.H/2)*s - 20, 0], heroCam);
    ctx.save();
    ctx.globalAlpha = 0.18;
    ctx.fillStyle = "#000";
    ctx.beginPath();
    ctx.ellipse(shadowPt.x, shadowPt.y + 100*k, 190*k, 55*k, 0, 0, Math.PI*2);
    ctx.fill();
    ctx.restore();

    drawBackpack3D(ctx, heroCam, p, s, mat.base);
  }

  /* =========================
     3D Interaction
  ========================== */
  let dragging=false, lx=0, ly=0;
  if (canvas) {
    canvas.style.cursor = "grab";
    canvas.addEventListener("mousedown", e => { dragging=true; lx=e.clientX; ly=e.clientY; canvas.style.cursor="grabbing"; });
    window.addEventListener("mouseup", () => { dragging=false; if(canvas) canvas.style.cursor="grab"; });
    window.addEventListener("mousemove", e => {
      if(!dragging) return;
      heroCam.ry += (e.clientX-lx)*0.01;
      heroCam.rx += (e.clientY-ly)*0.01;
      heroCam.rx  = clamp(heroCam.rx, 0.1, 1.4);
      lx=e.clientX; ly=e.clientY;
      requestDraw();
    });
    canvas.addEventListener("wheel", e => {
      e.preventDefault();
      heroCam.zoom *= e.deltaY<0 ? 1.08 : 0.92;
      heroCam.zoom  = clamp(heroCam.zoom, 0.4, 2.5);
      requestDraw();
    }, { passive: false });

    // Touch: single-finger drag to rotate, pinch to zoom.
    let pinchDist = 0;
    canvas.addEventListener("touchstart", e => {
      if (e.touches.length === 1) {
        dragging = true; lx = e.touches[0].clientX; ly = e.touches[0].clientY;
      } else if (e.touches.length === 2) {
        dragging = false;
        pinchDist = Math.hypot(
          e.touches[0].clientX - e.touches[1].clientX,
          e.touches[0].clientY - e.touches[1].clientY
        );
      }
    }, { passive: true });
    canvas.addEventListener("touchmove", e => {
      if (e.touches.length === 2 && pinchDist > 0) {
        e.preventDefault();
        const d = Math.hypot(
          e.touches[0].clientX - e.touches[1].clientX,
          e.touches[0].clientY - e.touches[1].clientY
        );
        heroCam.zoom = clamp(heroCam.zoom * (d / pinchDist), 0.4, 2.5);
        pinchDist = d;
        requestDraw();
        return;
      }
      if (!dragging || e.touches.length !== 1) return;
      e.preventDefault();
      const t = e.touches[0];
      heroCam.ry += (t.clientX - lx) * 0.01;
      heroCam.rx  = clamp(heroCam.rx + (t.clientY - ly) * 0.01, 0.1, 1.4);
      lx = t.clientX; ly = t.clientY;
      requestDraw();
    }, { passive: false });
    canvas.addEventListener("touchend",    () => { dragging = false; pinchDist = 0; }, { passive: true });
    canvas.addEventListener("touchcancel", () => { dragging = false; pinchDist = 0; }, { passive: true });

    let resizeTimer;
    window.addEventListener("resize", () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => { resizeCanvas(); drawPreview(); }, 120);
    });
  }

  function getHeroSnapshotCropped(targetW, targetH) {
    if (!canvas) return null;
    drawPreview();
    try {
      const srcW=canvas.width, srcH=canvas.height;
      const tRatio=targetW/targetH, sRatio=srcW/srcH;
      let cw, ch, cx2, cy2;
      if (sRatio > tRatio) { ch=srcH; cw=Math.round(srcH*tRatio); cx2=Math.round((srcW-cw)/2); cy2=0; }
      else                 { cw=srcW; ch=Math.round(srcW/tRatio);  cx2=0; cy2=Math.round((srcH-ch)/2); }
      const tmp=document.createElement("canvas"); tmp.width=cw; tmp.height=ch;
      tmp.getContext("2d").drawImage(canvas, cx2,cy2,cw,ch, 0,0,cw,ch);
      return tmp.toDataURL("image/png");
    } catch { return null; }
  }

  /* =========================
     SVG helpers
  ========================== */
  function trapPath(pad, wTop, wBot, h) {
    const dx = (wTop - wBot) / 2;
    const x1 = pad,          y1 = pad + h;
    const x2 = pad + wBot,   y2 = pad + h;
    const x3 = pad + wBot + dx, y3 = pad;
    const x4 = pad - dx + wBot + dx - wBot, y4 = pad;
    // simpler: centre the trapezoid
    const cx  = pad + wTop/2;
    const bHalf = wBot/2, tHalf = wTop/2;
    return `M ${cx-tHalf} ${pad} L ${cx+tHalf} ${pad} L ${cx+bHalf} ${pad+h} L ${cx-bHalf} ${pad+h} Z`;
  }

  function rectSVGPath(x,y,w,h) { return `M ${x} ${y} L ${x+w} ${y} L ${x+w} ${y+h} L ${x} ${y+h} Z`; }

  function buildPanelSVG({ title, pathD, svgW, svgH, seam, stitchD, extras="" }) {
    // Perpendicular seam allowance produces long floats; two decimals is plenty.
    svgW = Math.round(svgW * 100) / 100;
    svgH = Math.round(svgH * 100) / 100;
    return `<?xml version="1.0" encoding="UTF-8"?>
<svg xmlns="http://www.w3.org/2000/svg" width="${svgW}mm" height="${svgH}mm" viewBox="0 0 ${svgW} ${svgH}">
  <defs><style>
    .cut{fill:none;stroke:#000;stroke-width:0.8}
    .stitch{fill:none;stroke:#9a9a9a;stroke-width:0.28;stroke-dasharray:3 3}
    .title{font-family:Arial,Helvetica,sans-serif;font-size:6px;font-weight:700;fill:#2C5F2D}
    .meta{font-family:Arial,Helvetica,sans-serif;font-size:3.6px;fill:#333}
  </style></defs>
  <text x="15" y="9" class="title">${title}</text>
  <text x="15" y="14" class="meta">Units: mm · Cut line solid · Stitch line dashed · Seam = ${seam} mm</text>
  <path class="cut" d="${pathD}"/>
  <path class="stitch" d="${stitchD}"/>
  ${extras}
</svg>`;
  }

  function buildSVGStrings(params) {
    const g   = computePieces(params);
    const pad = 15;
    const s   = params.Seam;

    // Front/Back trapezoid
    const fc  = g.front.cut;
    const ftW = fc.wTop + pad*2;
    const ftH = fc.h    + pad*2;
    const frontCut    = trapPath(pad, fc.wTop, fc.wBot, fc.h);
    const frontStitch = trapPath(pad+s, g.front.wTop, g.front.wBot, g.front.h);

    // Rect pieces helper
    function rSVG(title, w, h) {
      const svgW = w+pad*2, svgH = h+pad*2;
      const cut    = rectSVGPath(pad,pad,w,h);
      const stitch = rectSVGPath(pad+s, pad+s, Math.max(0,w-2*s), Math.max(0,h-2*s));
      return buildPanelSVG({ title, pathD:cut, svgW, svgH, seam:s, stitchD:stitch });
    }

    // Side pocket — trapezoid (tall front edge, short back edge fixed 120mm)
    function buildSidePocketSVG(sp, seam, pad) {
      const w = sp.w, hF = sp.hFront, hB = sp.hBack;
      const svgW = w + pad*2;
      const svgH = Math.max(hF, hB) + pad*2;
      // Cut: tall (hF) on left (front), short (hB) on right (back)
      const x0=pad, y0B=pad+hB, y0T=pad+hF;
      const x1=pad+w;
      const cut    = `M ${x0} ${pad} L ${x1} ${pad} L ${x1} ${pad+hB} L ${x0} ${pad+hF} Z`;
      const stitch = `M ${x0+seam} ${pad+seam} L ${x1-seam} ${pad+seam} L ${x1-seam} ${pad+hB-seam} L ${x0+seam} ${pad+hF-seam} Z`;
      const title = "SIDE POCKET (elastic) — Cut 2x";
      return buildPanelSVG({ title, pathD:cut, svgW, svgH, seam, stitchD:stitch });
    }

    // Trapezoid piece helper (cut + stitch line)
    function tSVG(title, wTop, wBot, h) {
      return buildPanelSVG({
        title,
        pathD:   trapPath(pad,   wTop,     wBot,     h),
        stitchD: trapPath(pad+s, wTop-2*s, wBot-2*s, h-2*s),
        svgW: Math.max(wTop, wBot) + pad*2,
        svgH: h + pad*2,
        seam: s
      });
    }

    return {
      "RB_Front_Panel_Cut-1.svg":  buildPanelSVG({ title:"FRONT PANEL — Cut 1x", pathD:frontCut, svgW:ftW, svgH:ftH, seam:s, stitchD:frontStitch }),
      "RB_Back_Panel_Cut-1.svg":   tSVG("BACK PANEL — Cut 1x  (height = torso length)", g.backLower.cut.wTop, g.backLower.cut.wBot, g.backLower.cut.h),
      "RB_Back_Cover_Cut-1.svg":   tSVG("BACK COVER — Cut 1x",                          g.backCover.cut.wTop, g.backCover.cut.wBot, g.backCover.cut.h),
      "RB_Bottom_Panel_Cut-1.svg": rSVG("BOTTOM PANEL — Cut 1x", g.bottom.cut.w, g.bottom.cut.h),
      "RB_Side_Panel_Cut-2.svg":   rSVG("SIDE PANEL — Cut 2x",   g.side.cut.w,   g.side.cut.h),
    };
  }

  /* =========================
     PDF
  ========================== */
/* =========================
   A0 copyshop sheet — every piece at 1:1 on one sheet.
   Symmetric pieces are drawn as halves on a fold edge.
   Two passes: lay out first, then size the sheet to the content.
========================== */
/* =========================
   A0 copyshop sheet — every piece at 1:1 on one sheet.
   Symmetric pieces are drawn as halves on a fold edge.
   Mesh pockets are not separate pieces: their top edge is marked on the panel.
   Two passes: lay out first, then size the sheet to the content.
========================== */
  /* =========================
     Shared piece model
     One table, used by both the A0 copyshop sheet and the tiled A4 pages, so a
     piece can never say one thing on one sheet and something else on the other.
  ========================== */
  function mmA(n) { return Math.round(n * 100) / 100; }
  function clampN(v, lo, hi) { return Math.max(lo, Math.min(hi, v)); }

  function makePieceTable(params, g) {
    const LBL = 15;
    const s = params.Seam;
    const clamp = clampN;



  /* ---- derived hardware geometry -------------------------------------- */
  const strapW   = params.StrapW;
  const strapGap = params.StrapGap / 2;   // straps start where the line falls away
  const bc       = g.backCover;

  function halfWidthAt(wTop, wBot, h, yFromBot) {
    return (wBot + (wTop - wBot) * (yFromBot / h)) / 2;
  }

  const saddleYAt = bc.lineYAt;   // shoulder line height at a distance from the fold

  const compH = [
    clampN(params.Comp1, 40, g.side.h - 40),
    clampN(params.Comp2, 40, g.side.h - 40)
  ].sort(function (a, b) { return a - b; });

  // Chock cord loops on the front: three a side plus one at the bottom.
  // All three sit below the mesh top so they clear the pocket opening.
  const loopH = (function () {
    const lo = 40, hi = Math.max(lo + 20, params.FP - 25);
    return [lo, (lo + hi) / 2, hi];
  })();

  /* ---- piece table ----------------------------------------------------- */
  const P = [
    { key:"front", title:"FRONT PANEL", sub:"cut 1x on fold",
      fw:g.front.cut.wTop, bw:g.front.cut.wTop/2, bh:g.front.cut.h, kind:"trap",
      wTop:g.front.cut.wTop, wBot:g.front.cut.wBot, h:g.front.cut.h,
      fin:g.front, marks:"front" },

    { key:"back", title:"BACK PANEL", sub:"cut 1x on fold",
      fw:g.back.cut.wTop, bw:g.back.cut.wTop/2, bh:g.back.cut.h, kind:"trap",
      wTop:g.back.cut.wTop, wBot:g.back.cut.wBot, h:g.back.cut.h,
      fin:g.back, marks:"back" },

    { key:"side", title:"SIDE PANEL", sub:"cut 2x",
      fw:g.side.cut.w, bw:g.side.cut.w, bh:g.side.cut.h, kind:"rect",
      w:g.side.cut.w, h:g.side.cut.h, fin:g.side, marks:"side" },

    { key:"cover", title:"SHOULDER COVER", sub:"cut 1x on fold",
      fw:g.backCover.cut.halfWidth*2, bw:g.backCover.cut.halfWidth,
      bh:g.backCover.cut.h, kind:"coverstrip",
      w:g.backCover.cut.halfWidth, h:g.backCover.cut.h,
      fin:g.backCover, marks:"cover" },

    { key:"bottom", title:"BOTTOM PANEL", sub:"cut 1x on fold",
      fw:g.bottom.cut.w, bw:g.bottom.cut.w/2, bh:g.bottom.cut.h, kind:"halfrect",
      w:g.bottom.cut.w, h:g.bottom.cut.h, fin:g.bottom, marks:"bottom" },

    { key:"spocket", title:"SIDE POCKET", sub:"cut 2x mirrored",
      fw:g.sidePocket.cut.w, bw:g.sidePocket.cut.w, bh:g.sidePocket.cut.h,
      kind:"spocket", w:g.sidePocket.cut.w, h:g.sidePocket.cut.h,
      hF:g.sidePocket.hFront, hB:g.sidePocket.hBack,
      fin:{ w:g.sidePocket.w, h:Math.max(g.sidePocket.hFront, g.sidePocket.hBack) },
      marks:"spocket" },

    { key:"inner", title:"INNER DIVIDER POCKET", sub:"cut 1x on fold · optional",
      fw:g.innerPocket.cut.wTop, bw:g.innerPocket.cut.wTop/2, bh:g.innerPocket.cut.h,
      kind:"trap", wTop:g.innerPocket.cut.wTop, wBot:g.innerPocket.cut.wBot,
      h:g.innerPocket.cut.h, fin:g.innerPocket, marks:"inner" }
  ];

    return { pieces: P, LBL: LBL, s: s,
             halfWidthAt: halfWidthAt, saddleYAt: saddleYAt,
             compH: compH, loopH: loopH,
             strapW: strapW, strapGap: strapGap, bc: bc };
  }

  /* =========================
     Shared drawing, bound to one jsPDF document
  ========================== */
  function makePieceDrawer(pdf, params, g, T) {
  const GRAY   = [110, 110, 110];
  const BLUE   = [0, 80, 200];
  const GREEN  = [44, 95, 45];
  const ORANGE = [230, 120, 0];
  const RED    = [200, 40, 40];
  const PURPLE = [120, 60, 170];
    const s = params.Seam;
    const LBL = T.LBL;
    const halfWidthAt = T.halfWidthAt, saddleYAt = T.saddleYAt;
    const compH = T.compH, loopH = T.loopH;
    const strapW = T.strapW, strapGap = T.strapGap, bc = T.bc;

  function dash(d) { pdf.setLineDash(d || []); }
  function col(fn, c) { fn(c[0], c[1], c[2]); }

  function foldEdge(x, y, h) {
    col(pdf.setDrawColor.bind(pdf), BLUE); pdf.setLineWidth(0.7); dash([7, 4]);
    pdf.line(x, y, x, y + h);
    dash(); pdf.setDrawColor(0);
    pdf.setFont("helvetica", "italic"); pdf.setFontSize(7);
    col(pdf.setTextColor.bind(pdf), BLUE);
    pdf.text("FOLD — place on fabric fold", x + 3.2, y + h / 2, { angle: 90, baseline: "bottom" });
    pdf.setTextColor(0); pdf.setFont("helvetica", "normal");
  }

  function halfTrap(x, y, wTop, wBot, h) {
    const xT = x + wTop / 2, xB = x + wBot / 2;
    pdf.setDrawColor(0); pdf.setLineWidth(0.6); dash();
    pdf.lines([[xT - x, 0], [xB - xT, h], [x - xB, 0], [0, -h]], x, y, [1, 1], "S");
    pdf.setDrawColor(150); pdf.setLineWidth(0.3); dash([3, 3]);
    pdf.lines([
      [wTop / 2 - s, 0],
      [(wBot / 2 - s) - (wTop / 2 - s), h - 2 * s],
      [-(wBot / 2 - s), 0],
      [0, -(h - 2 * s)]
    ], x, y + s, [1, 1], "S");
    dash(); pdf.setDrawColor(0);
    foldEdge(x, y, h);
  }

  function halfRect(x, y, w, h) {
    const hw = w / 2;
    pdf.setDrawColor(0); pdf.setLineWidth(0.6); dash();
    pdf.lines([[hw, 0], [0, h], [-hw, 0], [0, -h]], x, y, [1, 1], "S");
    pdf.setDrawColor(150); pdf.setLineWidth(0.3); dash([3, 3]);
    pdf.lines([[hw - s, 0], [0, h - 2 * s], [-(hw - s), 0], [0, -(h - 2 * s)]], x, y + s, [1, 1], "S");
    dash(); pdf.setDrawColor(0);
    foldEdge(x, y, h);
  }

  function fullRect(x, y, w, h) {
    pdf.setDrawColor(0); pdf.setLineWidth(0.6); dash();
    pdf.rect(x, y, w, h, "S");
    pdf.setDrawColor(150); pdf.setLineWidth(0.3); dash([3, 3]);
    pdf.rect(x + s, y + s, w - 2 * s, h - 2 * s, "S");
    dash(); pdf.setDrawColor(0);
  }

  // Shoulder cover: top edge follows the shoulder line, bottom edge is straight,
  // sides follow the back panel. Tallest at the centre, narrowing to the edge.
  function coverStrip(x, y, it) {
    const nh = it.fin.neckHalf, eH = it.fin.cut.edgeH, W = it.w, H = it.h;
    const yEdgeTop = y + H - eH;
    pdf.setDrawColor(0); pdf.setLineWidth(0.6); dash();
    pdf.lines([[nh,0],[W-nh, H-eH],[0,eH],[-W,0],[0,-H]], x, y, [1,1], "S");
    pdf.setDrawColor(150); pdf.setLineWidth(0.3); dash([3,3]);
    pdf.lines([[nh,0],[W-nh-s, H-eH],[0,eH-2*s],[-(W-s),0],[0,-(H-2*s)]], x, y+s, [1,1], "S");
    dash(); pdf.setDrawColor(0);
    foldEdge(x, y, H);
    pdf.setFontSize(6.5); col(pdf.setTextColor.bind(pdf), GRAY);
    pdf.text(mmA(nh*2) + " mm flat between the straps, then " + mmA(params.ShoulderAngle) + "°",
      x + 3, y + H - 3);
    pdf.setTextColor(0);
  }

  // Side pocket: straight bottom, angled top (tall at the front edge).
  // Side pocket. Tall edge on the LEFT (front of the bag), short edge right.
  // The stitch line is offset perpendicular to the angled top, not vertically,
  // so it stays parallel to the cut line.
  function sidePocketShape(x, y, it) {
    const W = it.w, H = it.h;
    const drop = it.hF - it.hB;
    const m    = drop / W;
    const perp = (v) => v * Math.sqrt(1 + m * m);

    pdf.setDrawColor(0); pdf.setLineWidth(0.6); dash();
    pdf.lines([[W, drop], [0, H - drop], [-W, 0], [0, -H]], x, y, [1, 1], "S");

    // Two hem folds along the top: 25 mm, then 25 mm again.
    col(pdf.setDrawColor.bind(pdf), BLUE); pdf.setLineWidth(0.5);
    [1, 2].forEach(function (n) {
      dash(n === 1 ? [6, 3] : [2, 2]);
      const off = perp(CORD_CHANNEL * n);
      pdf.line(x, y + off, x + W, y + drop + off);
    });
    dash(); pdf.setDrawColor(0);
    pdf.setFontSize(6.5); col(pdf.setTextColor.bind(pdf), BLUE);
    pdf.text("fold twice — " + mmA(CORD_CHANNEL) + " mm channel for the chock cord",
      x + 4, y + perp(CORD_CHANNEL) - 2.5);
    pdf.setTextColor(0);

    // Stitch line: sides and bottom inset by s, top offset perpendicular, and
    // the top is the hem fold, not a seam, so it starts below the channel.
    const top0 = perp(2 * CORD_CHANNEL);
    const p1 = [x + s,     y + top0 + m * s];
    const p2 = [x + W - s, y + top0 + m * (W - s)];
    const p3 = [x + W - s, y + H - s];
    const p4 = [x + s,     y + H - s];
    pdf.setDrawColor(150); pdf.setLineWidth(0.3); dash([3, 3]);
    [[p1,p2],[p2,p3],[p3,p4],[p4,p1]].forEach(function (seg) {
      pdf.line(seg[0][0], seg[0][1], seg[1][0], seg[1][1]);
    });
    dash(); pdf.setDrawColor(0);
  }

  function meshTrap(x, y, wTop, wBot, h) {
    const cx = x + Math.max(wTop, wBot)/2;
    pdf.setDrawColor(0); pdf.setLineWidth(0.6); dash();
    pdf.lines([[wTop,0],[-(wTop-wBot)/2,h],[-wBot,0],[0,-h]], cx - wTop/2, y, [1,1], "S");
    dash(); pdf.setDrawColor(0);
  }

  /* ---- markings -------------------------------------------------------- */

  // Webbing attachment patch: filled box the width of the strap.
  // Attachment point. A small filled triangle whose apex sits exactly on the
  // point, plus a bar showing how wide the webbing is. The same symbol is used
  // for both strap ends so they read as the same kind of thing.
  function anchorMark(px, py, label, c, dir) {
    const r = 2.6, hgt = 4.2;          // mm
    col(pdf.setFillColor.bind(pdf), c);
    col(pdf.setDrawColor.bind(pdf), c);
    pdf.setLineWidth(0.3);
    if (dir === "left")       pdf.triangle(px, py, px + hgt, py - r, px + hgt, py + r, "F");
    else if (dir === "right") pdf.triangle(px, py, px - hgt, py - r, px - hgt, py + r, "F");
    else                      pdf.triangle(px, py, px - r, py - hgt, px + r, py - hgt, "F");
    pdf.setDrawColor(0);
    if (label) {
      pdf.setFont("helvetica", "bold"); pdf.setFontSize(6.5);
      col(pdf.setTextColor.bind(pdf), c);
      const lx = (dir === "left") ? px + hgt + 2 : (dir === "right") ? px - hgt - 2 : px;
      const ly = (dir === "down") ? py - hgt - 2 : py + 2.2;
      pdf.text(label, lx, ly,
        { align: (dir === "right") ? "right" : (dir === "down") ? "center" : "left" });
      pdf.setTextColor(0); pdf.setFont("helvetica", "normal");
    }
  }

  // The span of webbing at an attachment, drawn as a plain bar.
  function webbingSpan(x1, y1, x2, y2, c) {
    col(pdf.setDrawColor.bind(pdf), c); pdf.setLineWidth(1.6); dash();
    pdf.line(x1, y1, x2, y2);
    pdf.setDrawColor(0); pdf.setLineWidth(0.3);
  }

  // Mesh pocket top edge. Straight on the front panel, sloped on the side panel.
  function meshLine(pts, label) {
    col(pdf.setDrawColor.bind(pdf), ORANGE); pdf.setLineWidth(0.8); dash([6, 3]);
    for (let i = 0; i < pts.length - 1; i++) pdf.line(pts[i][0], pts[i][1], pts[i + 1][0], pts[i + 1][1]);
    dash(); pdf.setDrawColor(0);
    pdf.setFont("helvetica", "bold"); pdf.setFontSize(7);
    col(pdf.setTextColor.bind(pdf), ORANGE);
    pdf.text(label, pts[0][0] + 4, pts[0][1] - 2.5);
    pdf.setTextColor(0); pdf.setFont("helvetica", "normal");
  }

  // Solid orange: where the mesh itself is cut. Sides and bottom of the mesh are
  // caught in the panel seams, so it follows the panel CUT edge on those three
  // sides; only the top needs its own allowance for the elastic casing.
  function meshCutLine(pts, label) {
    col(pdf.setDrawColor.bind(pdf), ORANGE); pdf.setLineWidth(0.9); dash();
    for (let i = 0; i < pts.length - 1; i++) pdf.line(pts[i][0], pts[i][1], pts[i + 1][0], pts[i + 1][1]);
    pdf.setDrawColor(0);
    pdf.setFont("helvetica", "bold"); pdf.setFontSize(7);
    col(pdf.setTextColor.bind(pdf), ORANGE);
    pdf.text(label, pts[0][0] + 4, pts[0][1] - 2.5);
    pdf.setTextColor(0); pdf.setFont("helvetica", "normal");
  }

  function compMark(x, y, w, label) {
    col(pdf.setDrawColor.bind(pdf), PURPLE); pdf.setLineWidth(0.5); dash([3, 2]);
    pdf.line(x, y, x + w, y);
    dash();
    // anchor patches at both edges
    pdf.setLineWidth(0.6);
    pdf.rect(x, y - 6, 14, 12, "S");
    pdf.rect(x + w - 14, y - 6, 14, 12, "S");
    pdf.setDrawColor(0);
    pdf.setFont("helvetica", "bold"); pdf.setFontSize(6.5);
    col(pdf.setTextColor.bind(pdf), PURPLE);
    pdf.text(label, x + w / 2, y - 8, { align: "center" });
    pdf.setTextColor(0); pdf.setFont("helvetica", "normal");
  }

  // Markings are placed against the FINISHED edges, which sit one seam allowance
  // inside the cut outline.
  // Carry handle footprint: a box the size of the bartack, crossed corner to
  // corner, which is how it is actually sewn.
  function handleBox(cx, cy, label) {
    const w = 20, h = 40;
    const x0 = cx - w / 2, y0 = cy - h / 2;
    col(pdf.setDrawColor.bind(pdf), RED); pdf.setLineWidth(0.7); dash();
    pdf.rect(x0, y0, w, h, "S");
    pdf.setLineWidth(0.45);
    pdf.line(x0, y0, x0 + w, y0 + h);
    pdf.line(x0 + w, y0, x0, y0 + h);
    pdf.setDrawColor(0);
    pdf.setFont("helvetica", "bold"); pdf.setFontSize(6.5);
    col(pdf.setTextColor.bind(pdf), RED);
    pdf.text(label, x0 + w + 3, cy + 2);
    pdf.setTextColor(0); pdf.setFont("helvetica", "normal");
  }

  function loopMark(px, py, label, dir, labelDy) {
    const c = [0, 130, 120];
    col(pdf.setDrawColor.bind(pdf), c); pdf.setLineWidth(1.2); dash();
    pdf.line(px - (dir === "right" ? 8 : 0), py, px + (dir === "right" ? 0 : 8), py);
    pdf.setDrawColor(0);
    anchorMark(px, py, null, c, dir);
    if (label) {
      pdf.setFont("helvetica", "bold"); pdf.setFontSize(6.5);
      col(pdf.setTextColor.bind(pdf), c);
      const lx = (dir === "right") ? px - 10 : px + 10;
      pdf.text(label, lx, py + (labelDy || 0) + 2.2,
        { align: (dir === "right") ? "right" : "left" });
      pdf.setTextColor(0); pdf.setFont("helvetica", "normal");
    }
  }

  // Markings are placed against the FINISHED edges, one seam allowance inside
  // the cut outline.
  function drawMarks(kind, x, y, it) {
    const f  = it.fin;
    const yb = y + it.h - s;
    const xl = x + s, xr = x + it.w - s;

    if (kind === "front") {
      const yTop  = yb - params.FP;
      const halfW = halfWidthAt(f.wTop, f.wBot, f.h, params.FP);
      const yCut  = yTop - MESH_CASING;
      const cutHalf = halfWidthAt(it.wTop, it.wBot, it.h, (y + it.h) - yCut);

      meshCutLine([[x, yCut], [x + cutHalf, yCut]],
        "CUT MESH HERE — top edge of the mesh piece");
      col(pdf.setDrawColor.bind(pdf), ORANGE); pdf.setLineWidth(0.5); dash([3,2]);
      pdf.line(x, yTop - MESH_CASING/2, x + halfW, yTop - MESH_CASING/2);
      dash(); pdf.setDrawColor(0);
      pdf.setFontSize(6.5); col(pdf.setTextColor.bind(pdf), ORANGE);
      pdf.text("fold line — elastic casing", x + 4, yTop - MESH_CASING/2 - 2);
      pdf.setTextColor(0);
      meshLine([[x, yTop], [x + halfW, yTop]],
        "MESH POCKET TOP (finished) — " + mmA(params.FP) + " mm up");

      // Y-strap buckle, 40 mm above the mesh opening.
      const yBk = yTop - 40;
      webbingSpan(x, yBk - YSTRAP.webbing/2, x, yBk + YSTRAP.webbing/2, RED);
      anchorMark(x, yBk, "TOP Y-STRAP buckle — on the fold, 40 mm above the mesh", RED, "left");

      // Three chock cord loops up the side edge, all below the mesh opening.
      loopH.forEach(function (hMM, i) {
        const hw = halfWidthAt(f.wTop, f.wBot, f.h, hMM);
        loopMark(x + hw, yb - hMM,
          "CHOCK CORD LOOP " + (i+1) + " — " + mmA(hMM) + " mm (mirrored: 6 total)", "right");
      });
      // Fourth loop, centred on the bottom seam.
      loopMark(x, yb, "CHOCK CORD LOOP 4 — on the fold, bottom seam", "left", 7);

      const xIce = halfWidthAt(f.wTop, f.wBot, f.h, 0) - 30;
      loopMark(x + xIce, yb, "ICE AXE LOOP — 30 mm from the corner (2 total)", "right", -6);

    } else if (kind === "back") {
      const dIn = strapGap, dOut = strapGap + strapW;
      const yIn = yb - saddleYAt(dIn), yOut = yb - saddleYAt(dOut);
      webbingSpan(x + dIn, yIn, x + dOut, yOut, RED);
      anchorMark(x + (dIn+dOut)/2, (yIn+yOut)/2 - 1,
        "SHOULDER STRAP — upper, " + mmA(strapW) + " mm wide", RED, "down");

      col(pdf.setDrawColor.bind(pdf), GRAY); pdf.setLineWidth(0.4); dash([4,3]);
      pdf.line(x, yb - bc.centreFromBot, x + bc.neckHalf, yb - bc.centreFromBot);
      pdf.line(x + bc.neckHalf, yb - bc.centreFromBot, x + bc.halfWidth, yb - bc.edgeFromBot);
      dash(); pdf.setDrawColor(0);
      pdf.setFontSize(6.5); col(pdf.setTextColor.bind(pdf), GRAY);
      pdf.text("shoulder line — " + mmA(params.ShoulderAngle) + "° from the neck ("
        + mmA(bc.neckHalf*2) + " mm between the straps)", x + 4, yb - bc.centreFromBot - 2.5);
      pdf.setTextColor(0);

      // Carry handle: two bartacks 80 mm apart, so one box 40 mm from the fold.
      const yH = yb - bc.centreFromBot + 30;
      handleBox(x + 40, yH, "CARRY HANDLE — 40 mm from the fold (80 mm apart)");

      // Bladder hang loop: sewn before the cover so the cover hides the seam.
      loopMark(x, yb - bc.centreFromBot + 55,
        "BLADDER HANG LOOP — on the fold, covered by the shoulder cover", "left");

      // Lower shoulder strap: sits directly on top of the bottom stitch line.
      const halfLow = halfWidthAt(f.wTop, f.wBot, f.h, s);
      const yLow = yb - strapW / 2;
      webbingSpan(x + halfLow, yLow - strapW/2, x + halfLow, yLow + strapW/2, RED);
      anchorMark(x + halfLow, yb,
        "SHOULDER STRAP — lower, directly above the bottom seam", RED, "right");

    } else if (kind === "side") {
      compMark(xl, yb - compH[0], xr - xl, "SIDE COMPRESSION 1 — " + mmA(compH[0]) + " mm");
      compMark(xl, yb - compH[1], xr - xl, "SIDE COMPRESSION 2 — " + mmA(compH[1]) + " mm");
      pdf.setFontSize(6.5); col(pdf.setTextColor.bind(pdf), GRAY);
      pdf.text("BACK edge — the short side of the pocket goes here", xl + 2, yb - 16);
      pdf.text("FRONT edge", xr - 2, yb - 16, { align: "right" });
      pdf.setTextColor(0);
      // Two acceptable positions for the rolltop strap.
      webbingSpan(x + it.w/2 - 10, yb, x + it.w/2 + 10, yb, RED);
      anchorMark(x + it.w/2, yb, "ROLLTOP STRAP option 1 — centred on the bottom seam", RED, "down");
      webbingSpan(xl, yb - ROLLTOP_STRAP - 10, xl, yb - ROLLTOP_STRAP + 10, RED);
      anchorMark(xl, yb - ROLLTOP_STRAP,
        "ROLLTOP STRAP option 2 — back edge, " + mmA(ROLLTOP_STRAP) + " mm up", RED, "left");

    } else if (kind === "cover") {
      const axY = f.halfWidth * YSTRAP.anchorXFrac;
      const yAn = y + it.h * 0.5;
      webbingSpan(x + axY, yAn - YSTRAP.webbing/2, x + axY, yAn + YSTRAP.webbing/2, RED);
      anchorMark(x + axY, yAn, "TOP Y-STRAP anchor — " + mmA(axY)
        + " mm from the fold (mirrored: 2 total)", RED, "left");

    } else if (kind === "bottom") {
      // The front 50 mm of this piece turns up the front panel.
      const yW = y + s + g.bottom.wrap;
      col(pdf.setDrawColor.bind(pdf), BLUE); pdf.setLineWidth(0.5); dash([5,3]);
      pdf.line(x, yW, x + it.w/2, yW);
      dash(); pdf.setDrawColor(0);
      pdf.setFont("helvetica","bold"); pdf.setFontSize(7);
      col(pdf.setTextColor.bind(pdf), BLUE);
      pdf.text("turns up the FRONT — " + mmA(g.bottom.wrap) + " mm", x + 4, yW - 2.5);
      pdf.setTextColor(0); pdf.setFont("helvetica","normal");

    } else if (kind === "spocket") {
      const pv = g.sidePocket.volume / 2;
      col(pdf.setDrawColor.bind(pdf), BLUE); pdf.setLineWidth(0.5); dash([4,3]);
      pdf.line(xl + pv, yb - 45, xl + pv, yb);
      pdf.line(xr - pv, yb - 45, xr - pv, yb);
      dash(); pdf.setDrawColor(0);
      pdf.setFontSize(6.5); col(pdf.setTextColor.bind(pdf), BLUE);
      pdf.text("pleat " + mmA(pv) + " mm at the base (volume)", xl + pv + 2, yb - 43);
      pdf.setTextColor(0);
      pdf.setFontSize(6.5); col(pdf.setTextColor.bind(pdf), GRAY);
      pdf.text("TALL edge — front of the bag", xl + 2, yb - 55);
      pdf.text("SHORT edge — goes against the back", xr - 2, yb - 55, { align: "right" });
      pdf.setTextColor(0);
      loopMark(xl, y + (it.hF - it.hB) * 0 + 2 * CORD_CHANNEL + 14,
        "CHOCK CORD LOOP — 10 mm webbing, tall edge", "left");

    } else if (kind === "inner") {
      const yF = y + s + 25;
      col(pdf.setDrawColor.bind(pdf), BLUE); pdf.setLineWidth(0.5); dash([5,3]);
      pdf.line(x, yF, x + it.wTop/2, yF);
      dash(); pdf.setDrawColor(0);
      pdf.setFontSize(6.5); col(pdf.setTextColor.bind(pdf), BLUE);
      pdf.text("hem the top edge — 25 mm", xl + 3, yF - 2.5);
      pdf.setTextColor(0);
      pdf.setFontSize(6.5); col(pdf.setTextColor.bind(pdf), GRAY);
      pdf.text("Sides taper with the back panel. A 3 L bladder is ~410 mm tall, so it",
        x + 4, yF + 7);
      pdf.text("hangs from the loop on the back panel rather than standing in here.",
        x + 4, yF + 12);
      pdf.setTextColor(0);
    }
  }

  // Three chock cord loops up the front side edge, mirrored by the fold.
  function T4loops(x, y, it, f) {
    const yb = y + it.h - s;
    loopH.forEach(function (hMM, i) {
      const hw = halfWidthAt(f.wTop, f.wBot, f.h, hMM);
      loopMark(x + hw, yb - hMM,
        "CHOCK CORD LOOP " + (i+1) + " — " + mmA(hMM) + " mm (mirrored: 6 total)", "right");
    });
  }

    // Outline plus markings, origin at the piece's top-left corner.
    function drawBody(it, x, y) {
      if (it.kind === "trap") halfTrap(x, y, it.wTop, it.wBot, it.h);
      else if (it.kind === "halfrect") halfRect(x, y, it.w, it.h);
      else if (it.kind === "rect") fullRect(x, y, it.w, it.h);
      else if (it.kind === "coverstrip") coverStrip(x, y, it);
      else if (it.kind === "spocket") sidePocketShape(x, y, it);
      else if (it.kind === "meshtrap") meshTrap(x, y, it.wTop, it.wBot, it.h);
      if (it.marks) drawMarks(it.marks, x, y, it);
    }

    // Title strip above the piece (A0 sheet only; the A4 tiles have a header).
    function drawLabel(it, x, y) {
      pdf.setFont("helvetica", "bold"); pdf.setFontSize(11);
      col(pdf.setTextColor.bind(pdf), GREEN);
      pdf.text(it.title, x, y + 6);
      pdf.setFont("helvetica", "normal"); pdf.setFontSize(7.5);
      col(pdf.setTextColor.bind(pdf), GRAY);
      pdf.text(pieceDims(it), x, y + 11);
      pdf.setTextColor(0);
    }

  function legend(x, y) {
    const rows = [
      ["Solid black",   "CUT HERE",  "outer edge of every piece",        [0, 0, 0]],
      ["Dashed grey",   "SEW HERE",  mmA(s) + " mm inside the cut line", GRAY],
      ["Dashed blue",   "FOLD",      "place this edge on the fabric fold", BLUE],
      ["Solid orange",  "CUT MESH",  "mesh top, casing included",        ORANGE],
      ["Dashed orange", "MESH TOP",  "finished opening, elastic sits here", ORANGE],
      ["Red triangle",  "STRAP",     "webbing attachment, apex on the point", RED],
      ["Dashed purple", "COMPRESS",  "side compression strap",           PURPLE]
    ];
    rows.forEach(function (r, i) {
      const yy = y + i * 6;
      pdf.setFontSize(9); pdf.setFont("helvetica", "bold");
      col(pdf.setTextColor.bind(pdf), r[3]);
      pdf.text(r[0], x, yy);
      pdf.setFontSize(9.5);
      pdf.setTextColor(0);
      pdf.text(r[1], x + 28, yy);
      pdf.setFontSize(8); pdf.setFont("helvetica", "normal");
      col(pdf.setTextColor.bind(pdf), GRAY);
      pdf.text("— " + r[2], x + 52, yy);
    });
    pdf.setTextColor(0);
  }

    return { drawBody: drawBody, drawLabel: drawLabel, legend: legend,
             dash: dash, col: col, LBL: LBL,
             COLORS: { GRAY: GRAY, BLUE: BLUE, GREEN: GREEN, ORANGE: ORANGE, RED: RED, PURPLE: PURPLE } };
  }

  // One wording for a piece's size, shared by every output.
  function pieceDims(it) {
    const f = it.fin || {};
    if (it.kind === "coverstrip") {
      return it.sub + " · half shown, cut " + mmA(it.bw) + " × " + mmA(it.bh)
        + " mm · finished " + mmA(f.h) + " mm at the centre, "
        + mmA(f.edgeH) + " mm at the edge";
    }
    const finW = (f.wTop != null) ? f.wTop : f.w;
    return (it.bw === it.fw)
      ? it.sub + " · cut " + mmA(it.fw) + " × " + mmA(it.bh)
        + " mm · finished " + mmA(finW) + " × " + mmA(f.h) + " mm"
      : it.sub + " · half shown, cut " + mmA(it.bw) + " × " + mmA(it.bh)
        + " mm · finished full width " + mmA(finW) + " × " + mmA(f.h) + " mm";
  }

function buildA0Blob(params) {
  if (!window.jspdf || !window.jspdf.jsPDF) throw new Error("jsPDF not loaded");
  const jsPDF = window.jspdf.jsPDF;
  const g = computePieces(params);
  const T = makePieceTable(params, g);
  const P = T.pieces, LBL = T.LBL;
  const SHEET_W = 841, SHEET_H_MAX = 1189;   // A0 portrait, mm
  const MG = 18, GAP = 12;
  const HEAD_H = 62;   // header block plus the seven-row legend
  const s = params.Seam;

  /* ---- pass 1: layout (pure maths, no drawing) ------------------------- */
  function layout(sheetH) {
    const usableW = SHEET_W - MG * 2;
    const items = P.slice().sort(function (a, b) { return (b.bh + LBL) - (a.bh + LBL); });
    const pages = [{ shelves: [] }];

    function newShelf(pageIdx, h, force) {
      const pg = pages[pageIdx];
      const last = pg.shelves[pg.shelves.length - 1];
      const top = last ? last.y + last.h + GAP : (pageIdx === 0 ? MG + HEAD_H : MG);
      // force=true is the last resort for a piece taller than a whole sheet:
      // better to emit it slightly over the margin than to fail the download.
      if (!force && top + h > sheetH - MG) return null;
      const sh = { y: top, h: h, used: 0, items: [] };
      pg.shelves.push(sh);
      return sh;
    }

    for (const it of items) {
      const w = it.bw, h = it.bh + LBL;
      let done = false;
      for (let pi = 0; pi < pages.length && !done; pi++) {
        for (const sh of pages[pi].shelves) {
          const need = sh.used ? sh.used + GAP + w : w;
          if (need <= usableW && h <= sh.h) {
            sh.items.push({ it: it, x: MG + (sh.used ? sh.used + GAP : 0), y: sh.y });
            sh.used = need; done = true; break;
          }
        }
        if (done) break;
        const sh = newShelf(pi, h);
        if (sh) { sh.items.push({ it: it, x: MG, y: sh.y }); sh.used = w; done = true; }
      }
      if (!done) {
        pages.push({ shelves: [] });
        const sh = newShelf(pages.length - 1, h, true);
        sh.items.push({ it: it, x: MG, y: sh.y }); sh.used = w;
      }
    }

    let bottom = 0;
    pages.forEach(function (pg) { pg.shelves.forEach(function (sh) { bottom = Math.max(bottom, sh.y + sh.h); }); });
    return { pages: pages, bottom: bottom };
  }

  const trial = layout(SHEET_H_MAX);
  const single = trial.pages.length === 1;
  const sheetH = single ? Math.min(SHEET_H_MAX, Math.max(400, Math.ceil(trial.bottom + MG))) : SHEET_H_MAX;
  const L = trial;

  /* ---- pass 2: draw ---------------------------------------------------- */
  // jsPDF swaps the format to match the orientation, so derive it instead of
  // hardcoding "portrait" — a trimmed sheet is often wider than it is tall.
  const ORIENT = (sheetH >= SHEET_W) ? "portrait" : "landscape";
  const pdf = new jsPDF({ unit: "mm", format: [SHEET_W, sheetH], orientation: ORIENT, compress: true });
  const D = makePieceDrawer(pdf, params, g, T);
  const dash = D.dash, col = D.col;
  const GRAY = D.COLORS.GRAY, GREEN = D.COLORS.GREEN;

  function drawPiece(it, x, y) { D.drawLabel(it, x, y); D.drawBody(it, x, y + LBL); }
  function legend(x, y) { D.legend(x, y); }

  function header() {
    pdf.setFont("helvetica", "bold"); pdf.setFontSize(24);
    col(pdf.setTextColor.bind(pdf), GREEN);
    pdf.text("ROLLTOP BACKPACK — copyshop sheet, 1:1", MG, MG + 9);
    pdf.setFont("helvetica", "normal"); pdf.setFontSize(10); pdf.setTextColor(0);
    pdf.text("Width " + mmA(params.Wt) + "/" + mmA(params.Wb) + " mm · Height " + mmA(params.H)
      + " mm · Depth " + mmA(params.D) + " mm · Torso " + mmA(params.Torso)
      + " mm · Seam " + mmA(params.Seam) + " mm", MG, MG + 17);
    pdf.setFontSize(9); col(pdf.setTextColor.bind(pdf), GRAY);
    pdf.text("Print at 100%, no scaling. Sheet " + SHEET_W + " × " + Math.round(sheetH) + " mm. "
      + "Dimensions above are the FINISHED bag — " + mmA(s) + " mm seam allowance is already "
      + "added outside every cut line. Mesh pockets have no pattern piece.", MG, MG + 25);
    pdf.setTextColor(0);

    legend(SHEET_W / 2 - 40, MG + 2);
    pdfAddLogo(pdf, SHEET_W - MG - 140, MG - 2, 70, 18);

    const cx = SHEET_W - MG - 50, cy = MG - 4;
    pdf.setDrawColor(0); pdf.setLineWidth(0.5); dash();
    pdf.rect(cx, cy, 50, 50, "S");
    pdf.setFontSize(8);
    pdf.text("50 × 50 mm", cx + 25, cy + 25, { align: "center" });
    pdf.text("measure before cutting", cx + 25, cy + 31, { align: "center" });
  }

  L.pages.forEach(function (pg, pi) {
    if (pi > 0) pdf.addPage([SHEET_W, sheetH], ORIENT);
    if (pi === 0) header();
    else {
      pdf.setFont("helvetica", "bold"); pdf.setFontSize(12);
      col(pdf.setTextColor.bind(pdf), GREEN);
      pdf.text("ROLLTOP BACKPACK — copyshop sheet " + (pi + 1) + "/" + L.pages.length, MG, MG + 6);
      pdf.setTextColor(0);
    }
    pg.shelves.forEach(function (sh) {
      sh.items.forEach(function (o) { drawPiece(o.it, o.x, o.y); });
    });
  });

  return pdf.output("blob");
}

  function buildPDFBlob(params) {
    if (!window.jspdf?.jsPDF) throw new Error("jsPDF not loaded");
    const { jsPDF } = window.jspdf;
    const T4 = makePieceTable(params, computePieces(params));
    const pdf = new jsPDF({ unit:"mm", format:"a4", compress:true });

    const PAGE_W=210, PAGE_H=297, M=15, HEADER_H=26;
    const BOTTOM_SAFE=PAGE_H-40;
    const USABLE_W=PAGE_W-M*2;
    const USABLE_H=BOTTOM_SAFE-(M+HEADER_H);

    const GREEN=[44,95,45], YELLOW=[255,227,60], GRAY=[120,120,120];
    const LOGO_W=52, LOGO_H=13.4;

    const g = computePieces(params);

    function header(title, subtitle="") {
      pdfAddLogo(pdf, PAGE_W-M-LOGO_W, 6, LOGO_W, LOGO_H);
      pdf.setFont("helvetica","bold"); pdf.setFontSize(18); pdf.setTextColor(...GREEN);
      pdf.text(title, PAGE_W/2, 18, {align:"center"});
      if (subtitle) { pdf.setFont("helvetica","normal"); pdf.setFontSize(10); pdf.setTextColor(0); pdf.text(subtitle, PAGE_W/2, 25, {align:"center"}); }
      pdf.setDrawColor(...YELLOW); pdf.setLineWidth(1); pdf.line(M,30,PAGE_W-M,30); pdf.setDrawColor(0);
    }

    function footerCenter(t) {
      pdf.setFont("helvetica","normal"); pdf.setFontSize(8); pdf.setTextColor(...GRAY);
      pdf.text(t, PAGE_W/2, PAGE_H-10, {align:"center"}); pdf.setTextColor(0);
    }

    function scaleLine100(x=M, y=PAGE_H-20) {
      pdf.setDrawColor(0); pdf.setLineWidth(0.6);
      pdf.line(x,y,x+100,y); pdf.line(x,y-5,x,y+5); pdf.line(x+100,y-5,x+100,y+5);
      pdf.setFont("helvetica","normal"); pdf.setFontSize(8); pdf.setTextColor(0);
      pdf.text("Scale check: 100 mm", x, y-7);
    }

    function scaleBox50(x=M, y=PAGE_H-68) {
      pdf.setDrawColor(0); pdf.setLineWidth(0.4); pdf.rect(x,y,50,50);
      pdf.setFont("helvetica","normal"); pdf.setFontSize(8); pdf.setTextColor(0);
      pdf.text("Scale test: 50 × 50 mm", x, y-4);
    }

    function regMarks(x,y,w,h) {
      const m=6; pdf.setLineWidth(0.35); pdf.setDrawColor(0);
      pdf.line(x,y,x+m,y); pdf.line(x,y,x,y+m);
      pdf.line(x+w,y,x+w-m,y); pdf.line(x+w,y,x+w,y+m);
      pdf.line(x,y+h,x+m,y+h); pdf.line(x,y+h,x,y+h-m);
      pdf.line(x+w,y+h,x+w-m,y+h); pdf.line(x+w,y+h,x+w,y+h-m);
    }

    function tileHeader(pieceTitle, tileLabel) {
      pdfAddLogo(pdf, PAGE_W-M-LOGO_W, 4, LOGO_W, LOGO_H);
      pdf.setFont("helvetica","bold"); pdf.setFontSize(13); pdf.setTextColor(...GREEN);
      pdf.text("ROLLTOP BACKPACK", M, M+6); pdf.setTextColor(0);
      pdf.setFontSize(10); pdf.text(pieceTitle, M, M+13);
      pdf.setFont("helvetica","normal"); pdf.setFontSize(9); pdf.setTextColor(...GRAY);
      pdf.text(tileLabel, PAGE_W-M-LOGO_W-4, M+13, {align:"right"}); pdf.setTextColor(0);
    }

    // Half-trapezoid: cut on RIGHT side (centrefolded on left = fold line)
    // wTop/wBot are FULL widths — we draw half of them.
    // The fold line is on the LEFT edge of the drawn shape.
    function drawHalfTrapCutStitch(x,y,wTop,wBot,h,seam) {
      const htH = wTop/4, hbH = wBot/4; // half of half-widths
      // Shape: top-left (fold), top-right, bot-right, bot-left (fold)
      // Using pdf.lines from (x, y):
      //   right along top:   [wTop/2, 0]
      //   down-inward:       [(wBot-wTop)/4*2, h]  = [hbH-htH… wait use absolute]
      // Simpler with explicit coords:
      const x0=x, x1=x+wTop/2, x2=x+wBot/2;
      pdf.setDrawColor(0); pdf.setLineWidth(0.6);
      pdf.lines([
        [x1-x0,  0],   // top edge (right)
        [x2-x1,  h],   // right slanted edge
        [x0-x2,  0],   // bottom edge (left)
        [0,     -h]    // fold line (vertical left edge)
      ], x0, y, [1,1], "S");

      // Fold line marker (blue dashed + text)
      pdf.setDrawColor(0,80,200); pdf.setLineWidth(0.5); pdf.setLineDash([6,3]);
      pdf.line(x0, y, x0, y+h);
      pdf.setLineDash([]); pdf.setDrawColor(0);
      pdf.setFont("helvetica","italic"); pdf.setFontSize(6); pdf.setTextColor(0,80,200);
      pdf.text("← FOLD LINE (cut on fold)", x0+2, y+h/2, {angle:90, baseline:"bottom"});
      pdf.setTextColor(0); pdf.setFont("helvetica","normal");

      // Stitch line (inset seam on right/top/bottom, not on fold)
      const isW2 = (wTop/2)-seam, ibW2 = (wBot/2)-seam;
      pdf.setDrawColor(140); pdf.setLineWidth(0.3); pdf.setLineDash([3,3]);
      pdf.lines([
        [isW2,        0],
        [ibW2-isW2,   h-2*seam],
        [-ibW2,       0],
        [0,           -(h-2*seam)]
      ], x0+0, y+seam, [1,1], "S");
      pdf.setLineDash([]); pdf.setDrawColor(0);
    }

    function drawPanelTrapCutStitch(x,y,wTop,wBot,h,seam) {
      // Trapezoid wider at top (wTop) narrower at bottom (wBot).
      // Start: top-left corner (cx-tH, y), clockwise:
      //   [+tH*2,    0] → top-right
      //   [bH-tH,   +h] → bot-right  (bH-tH < 0 when wTop>wBot, so inward ✓)
      //   [-bH*2,    0] → bot-left
      //   [bH-tH,   -h] → back to top-left  ← FIX: was tH-bH (wrong sign)
      const cx = x + wTop/2;
      const tH = wTop/2, bH = wBot/2;

      pdf.setDrawColor(0); pdf.setLineWidth(0.6);
      pdf.lines([
        [ tH*2,  0],
        [bH-tH,  h],
        [-bH*2,  0],
        [bH-tH, -h]   // corrected: was tH-bH which caused left side to lean wrong way
      ], cx-tH, y, [1,1], "S");

      const itH = (wTop-2*seam)/2, ibH = (wBot-2*seam)/2, iH = h-2*seam;
      pdf.setDrawColor(140); pdf.setLineWidth(0.3); pdf.setLineDash([3,3]);
      pdf.lines([
        [ itH*2,    0],
        [ibH-itH,  iH],
        [-ibH*2,    0],
        [ibH-itH, -iH]  // same fix for stitch line
      ], cx-itH, y+seam, [1,1], "S");
      pdf.setLineDash([]); pdf.setDrawColor(0);
    }

    function drawRectCutStitch(x,y,w,h,seam) {
      pdf.setDrawColor(0); pdf.setLineWidth(0.6); pdf.rect(x,y,w,h);
      pdf.setDrawColor(140); pdf.setLineWidth(0.3); pdf.setLineDash([3,3]);
      pdf.rect(x+seam,y+seam,Math.max(0,w-2*seam),Math.max(0,h-2*seam));
      pdf.setLineDash([]); pdf.setDrawColor(0);
    }

    // Draw side pocket trapezoid: angled edge at TOP (opening), straight bottom.
    // Left edge = hFront (tall, front of bag), right edge = hBack (short, back of bag)
    // Corners: A=top-left(x,y), B=top-right(x+w, y+dH), C=bot-right(x+w, y+hF), D=bot-left(x, y+hF)
    // where dH = hF-hB  (height difference, so B is lower than A = angled opening)
    function drawTrapCutStitch(x,y,w,hF,hB,seam) {
      const dH = hF - hB;
      // Cut outline (clockwise from A):
      pdf.setDrawColor(0); pdf.setLineWidth(0.6);
      pdf.lines([
        [w,   dH],    // A→B: sned topp (höger kant är lägre)
        [0,   hB],    // B→C: höger kant ned
        [-w,   0],    // C→D: botten horisontell
        [0,  -hF]     // D→A: vänster kant upp
      ], x, y, [1,1], "S");

      // Stitch line: truly parallel to each cut edge (miter corners)
      // Derived formulas for inset corners (see geometry derivation):
      //   L = sqrt(w² + dH²)
      //   A' = (x+seam,          y + seam*(L+dH)/w )
      //   B' = (x+w-seam,        y + dH + seam*(L-dH)/w )
      //   C' = (x+w-seam,        y + hF - seam )
      //   D' = (x+seam,          y + hF - seam )
      const L = Math.sqrt(w*w + dH*dH);
      const ax = x+seam,        ay = y + seam*(L+dH)/w;
      const bx = x+w-seam,      by = y + dH + seam*(L-dH)/w;
      const cx2 = x+w-seam,     cy2 = y+hF-seam;
      const dx2 = x+seam,       dy2 = y+hF-seam;
      pdf.setDrawColor(140); pdf.setLineWidth(0.3); pdf.setLineDash([3,3]);
      pdf.lines([
        [bx-ax, by-ay],   // A'→B' parallel to sned topp
        [cx2-bx, cy2-by], // B'→C' parallel to höger kant
        [dx2-cx2, 0],     // C'→D' parallel to botten
        [0, ay-dy2]       // D'→A' parallel to vänster kant
      ], ax, ay, [1,1], "S");
      pdf.setLineDash([]); pdf.setDrawColor(0);
    }

    // Draw elastic casing fold line on front pocket
    function drawElasticCasingMark(x,y,w,casingH,seam) {
      const foldY = y + casingH; // fold line at top of visible pocket
      pdf.setDrawColor(200,130,0); pdf.setLineWidth(0.5); pdf.setLineDash([5,3]);
      pdf.line(x, foldY, x+w, foldY);
      pdf.setLineDash([]); pdf.setDrawColor(0);
      pdf.setFont("helvetica","italic"); pdf.setFontSize(7); pdf.setTextColor(180,100,0);
      pdf.text("← fold & sew elastic casing →", x+w/2, foldY-2, {align:"center"});
      pdf.setTextColor(0); pdf.setFont("helvetica","normal");
    }

    function drawNotches(x,y,w,h) {
      // Tick mark ON the cut line, label INSIDE the shape
      const cx=x+w/2, cy2=y+h/2;
      const INSIDE = 9; // mm inward from edge
      function notch(px,py,dir,lbl,len=6) {
        const half=len/2; pdf.setLineWidth(0.5);
        if(dir==="up"||dir==="down") pdf.line(px,py-half,px,py+half);
        else pdf.line(px-half,py,px+half,py);
        let tx=px, ty=py;
        if(dir==="up")    ty=py+INSIDE;   // top edge → label below (inside)
        if(dir==="down")  ty=py-INSIDE;   // bottom edge → label above (inside)
        if(dir==="left")  tx=px+INSIDE;   // left edge → label to right (inside)
        if(dir==="right") tx=px-INSIDE;   // right edge → label to left (inside)
        pdf.setFont("helvetica","bold"); pdf.setFontSize(8);
        pdf.text(lbl,tx,ty,{align:"center"});
      }
      notch(cx,y,"up","A");         // top centre
      notch(cx,y+h,"down","A");     // bottom centre
      notch(x,cy2,"left","B",9);    // left mid
      notch(x+w,cy2,"right","C",9); // right mid
    }


    /* =========================
       Hardware placement markers
    ========================== */
    const COL_HW  = [180, 90, 0];    // orange — hardware marks
    const COL_REM = [44, 95, 45];    // green — strap marks
    const COL_HIP = [150, 0, 150];   // purple — hip belt

    // Cross-hair marker with label
    function hwMark(px, py, lbl, col=COL_HW, sz=5) {
      pdf.setDrawColor(...col); pdf.setLineWidth(0.6);
      pdf.line(px-sz, py, px+sz, py);
      pdf.line(px, py-sz, px, py+sz);
      // Circle
      pdf.circle(px, py, sz*0.6);
      pdf.setFont("helvetica","bold"); pdf.setFontSize(6.5); pdf.setTextColor(...col);
      pdf.text(lbl, px, py+sz+4, {align:"center"});
      pdf.setTextColor(0); pdf.setDrawColor(0); pdf.setFont("helvetica","normal");
    }

    // Strap attachment box: two vertical sew lines at px±halfW, from py to py+h
    // Represents a folded strap sewn down with a box-X stitch
    function strapMark(px, py, w, h, lbl, col=COL_REM) {
      const x0=px-w/2, x1=px+w/2;
      pdf.setDrawColor(...col); pdf.setLineWidth(0.5);
      // Outline box
      pdf.rect(x0, py, w, h);
      // Diagonal X stitching inside
      pdf.setLineDash([2,2]);
      pdf.line(x0, py, x1, py+h);
      pdf.line(x1, py, x0, py+h);
      pdf.setLineDash([]);
      // Buckle symbol (small rectangle above)
      pdf.rect(x0+w*0.2, py-5, w*0.6, 4);
      pdf.setFont("helvetica","bold"); pdf.setFontSize(6.5); pdf.setTextColor(...col);
      pdf.text(lbl, px, py+h+5, {align:"center"});
      pdf.setTextColor(0); pdf.setDrawColor(0); pdf.setFont("helvetica","normal");
    }

    // Horizontal band marker (hip belt zone etc)
    function bandMark(x, y, w, h, lbl, col=COL_HIP) {
      pdf.setDrawColor(...col); pdf.setFillColor(...col.map(c=>Math.min(255,c+160)));
      pdf.setLineWidth(0.5); pdf.setLineDash([3,2]);
      pdf.rect(x, y, w, h, "FD");
      pdf.setLineDash([]);
      pdf.setFont("helvetica","bold"); pdf.setFontSize(6.5); pdf.setTextColor(...col);
      pdf.text(lbl, x+w/2, y+h/2+2, {align:"center"});
      pdf.setTextColor(0); pdf.setDrawColor(0); pdf.setFont("helvetica","normal");
    }

    // Lug/loop marker (eyelet for cord loop)
    function lugMark(px, py, lbl, col=COL_HW) {
      const r=3;
      pdf.setDrawColor(...col); pdf.setLineWidth(0.5);
      pdf.circle(px, py, r);          // outer ring
      pdf.circle(px, py, r*0.4);      // inner hole
      // tick marks top/bottom/left/right
      [[0,-r-2],[0,r+2],[-r-2,0],[r+2,0]].forEach(([dx,dy])=>{
        pdf.line(px+dx*0.3, py+dy*0.3, px+dx, py+dy);
      });
      pdf.setFont("helvetica","bold"); pdf.setFontSize(5.5); pdf.setTextColor(...col);
      pdf.text(lbl, px, py+r+5, {align:"center"});
      pdf.setTextColor(0); pdf.setDrawColor(0); pdf.setFont("helvetica","normal");
    }

    // Tiles overlap so the sheets can actually be taped together, and each page
    // is clipped to its own tile — otherwise the neighbouring tile's content
    // bleeds across the margins, the footer and the registration marks.
    const OVERLAP = 12;                       // mm of shared area between tiles
    const STEP_X  = USABLE_W - OVERLAP;
    const STEP_Y  = USABLE_H - OVERLAP;

    function glueEdge(x, y, w, h, right, bottom) {
      pdf.setDrawColor(150); pdf.setLineWidth(0.25); pdf.setLineDash([2,2]);
      if (right)  pdf.line(x + w - OVERLAP, y, x + w - OVERLAP, y + h);
      if (bottom) pdf.line(x, y + h - OVERLAP, x + w, y + h - OVERLAP);
      pdf.setLineDash([]); pdf.setDrawColor(0);
      pdf.setFontSize(6); pdf.setTextColor(...GRAY);
      if (right)  pdf.text("overlap — trim here or tape over", x + w - OVERLAP + 1.5, y + 6, { angle: 90, baseline: "bottom" });
      if (bottom) pdf.text("overlap — trim here or tape over", x + 2, y + h - OVERLAP - 1.5);
      pdf.setTextColor(0);
    }

    function addTiledPiece({ pieceTitle, subTitle, w, h, drawWorld }) {
      const tilesX = Math.max(1, Math.ceil((w - OVERLAP) / STEP_X));
      const tilesY = Math.max(1, Math.ceil((h - OVERLAP) / STEP_Y));
      let idx=0;
      for (let ty=0;ty<tilesY;ty++) for (let tx=0;tx<tilesX;tx++) {
        idx++;
        pdf.addPage();
        tileHeader(pieceTitle, `Tile ${idx}/${tilesX*tilesY}  (Row ${ty+1}/${tilesY}, Col ${tx+1}/${tilesX})`);
        if (subTitle) {
          pdf.setFont("helvetica","normal"); pdf.setFontSize(7.5); pdf.setTextColor(...GRAY);
          pdf.text(subTitle, M, M+19); pdf.setTextColor(0);
        }
        const aX=M, aY=M+HEADER_H, aW=USABLE_W, aH=USABLE_H;
        regMarks(aX,aY,aW,aH);
        glueEdge(aX, aY, aW, aH, tx < tilesX-1, ty < tilesY-1);

        pdf.saveGraphicsState();
        pdf.rect(aX, aY, aW, aH, null);
        pdf.clip();
        pdf.discardPath();
        drawWorld(aX-tx*STEP_X, aY-ty*STEP_Y);
        pdf.restoreGraphicsState();

        scaleLine100(M, PAGE_H-20);
        const rX=M+120; pdf.setFont("helvetica","normal"); pdf.setFontSize(8); pdf.setTextColor(...GRAY);
        pdf.text(`Cut solid · Sew dashed · Seam = ${mm(params.Seam)} mm (already added)`, rX, PAGE_H-34);
        pdf.text("Print 100% (do not scale)", rX, PAGE_H-28);
        pdf.text("Rolltop Backpack · Pattern tile · Scale 1:1", rX, PAGE_H-12);
        pdf.setTextColor(0);
      }
    }

    /* ---- COVER ---- */
    const COVER_LOGO_W=80, COVER_LOGO_H=20.6;
    pdfAddLogo(pdf, (PAGE_W-COVER_LOGO_W)/2, 8, COVER_LOGO_W, COVER_LOGO_H);
    pdf.setDrawColor(...YELLOW); pdf.setLineWidth(6); pdf.line(M,38,PAGE_W-M,38); pdf.setLineWidth(0.2);

    pdf.setFont("helvetica","bold"); pdf.setFontSize(26); pdf.setTextColor(...GREEN);
    pdf.text("ROLLTOP BACKPACK", PAGE_W/2, 55, {align:"center"});
    pdf.setFont("helvetica","normal"); pdf.setFontSize(11); pdf.setTextColor(60);
    pdf.text("Parametric sewing pattern · Print-at-home", PAGE_W/2, 62, {align:"center"});

    const cardX=M, cardY=74, cardW=90, cardH=110;
    pdf.setDrawColor(200); pdf.setFillColor(245,247,245);
    pdf.roundedRect(cardX,cardY,cardW,cardH,6,6,"FD");
    const heroImg = getHeroSnapshotCropped(cardW,cardH);
    if (heroImg) { try { pdf.addImage(heroImg,"PNG",cardX,cardY,cardW,cardH); } catch{} }

    const infoX=cardX+cardW+8, infoY=cardY, infoW=PAGE_W-M-infoX, infoH=cardH;
    pdf.setDrawColor(220); pdf.setFillColor(255,255,255);
    pdf.roundedRect(infoX,infoY,infoW,infoH,6,6,"FD");

    pdf.setFillColor(...YELLOW); pdf.setDrawColor(220);
    pdf.roundedRect(infoX+infoW-26,infoY+6,20,10,5,5,"FD");
    pdf.setFont("helvetica","bold"); pdf.setFontSize(9); pdf.setTextColor(0);
    pdf.text("A4", infoX+infoW-16, infoY+13, {align:"center"});

    pdf.setFont("helvetica","bold"); pdf.setFontSize(12); pdf.setTextColor(...GREEN);
    pdf.text("Finished size", infoX+8, infoY+18);
    pdf.setFont("helvetica","normal"); pdf.setFontSize(10); pdf.setTextColor(0);
    pdf.text(`Top ${mm(params.Wt)} · Bot ${mm(params.Wb)} · H ${mm(params.H)} mm`, infoX+8, infoY+26);
    pdf.text(`Depth ${mm(params.D)} · Rolltop ${mm(ROLLTOP)} mm · Torso ${mm(params.Torso)} mm`, infoX+8, infoY+33);

    pdf.setFont("helvetica","bold"); pdf.setFontSize(12); pdf.setTextColor(...GREEN);
    pdf.text("Pockets", infoX+8, infoY+47);
    pdf.setFont("helvetica","normal"); pdf.setFontSize(10); pdf.setTextColor(0);
    pdf.text(`Front mesh top: ${mm(params.FP)} mm above panel bottom`, infoX+8, infoY+55);
    pdf.text(`Side mesh top: ${mm(params.SPfront)} mm front / ${mm(params.SPback)} mm back`, infoX+8, infoY+62);

    pdf.setFont("helvetica","bold"); pdf.setFontSize(12); pdf.setTextColor(...GREEN);
    pdf.text("Quick notes", infoX+8, infoY+76);
    pdf.setFont("helvetica","normal"); pdf.setFontSize(10); pdf.setTextColor(0);
    const bullets=["Print at 100% (no fit to page).","Check the 50×50 mm box.","Cut solid · Sew dashed.","Use registration marks for tiling."];
    let by=infoY+84;
    bullets.forEach(t => { pdf.text("•",infoX+8,by); pdf.text(t,infoX+12,by); by+=7; });

    const stripY=196;
    pdf.setDrawColor(230); pdf.setFillColor(255,255,255);
    pdf.roundedRect(M,stripY,PAGE_W-2*M,72,6,6,"FD");
    pdf.setFont("helvetica","bold"); pdf.setFontSize(12); pdf.setTextColor(...GREEN);
    pdf.text("Cut list (summary)", M+10, stripY+14);
    pdf.setFont("helvetica","normal"); pdf.setFontSize(10); pdf.setTextColor(0);
    pdf.text("1) Front panel — cut 1x", M+10, stripY+24);
    pdf.text("2) Back panel — cut 1x   (height = torso length)", M+10, stripY+31);
    pdf.text("3) Back cover piece — cut 1x   (covers shoulder strap attachment)", M+10, stripY+38);
    pdf.text("4) Side panels — cut 2x", M+10, stripY+45);
    pdf.text("5) Bottom panel — cut 1x", M+10, stripY+52);
    pdf.text("Mesh pockets have no pattern piece — see the marked line on the front and side panels.", M+10, stripY+59);

    pdf.setFont("helvetica","normal"); pdf.setFontSize(8); pdf.setTextColor(...GRAY);
    pdf.text("Rolltop Backpack · Generated pattern · v1", PAGE_W-M, PAGE_H-12, {align:"right"});
    pdf.setTextColor(0);
    footerCenter("friluftstyger.se · Make Your Own Gear");

    /* ---- CUT LIST ---- */
    pdf.addPage();
    header("CUT LIST","All pieces with dimensions");
    pdf.setFont("helvetica","normal"); pdf.setFontSize(10);
    const cl = [
      ["1) Front panel — cut 1x",              `Cut ${mm(g.front.cut.wTop)}/${mm(g.front.cut.wBot)} × ${mm(g.front.cut.h)} mm · finished ${mm(g.front.wTop)}/${mm(g.front.wBot)} × ${mm(g.front.h)} mm`],
      ["2) Back panel — cut 1x",               `Cut ${mm(g.backLower.cut.wTop)}/${mm(g.backLower.cut.wBot)} × ${mm(g.backLower.cut.h)} mm · finished height ${mm(g.backLower.h)} mm (torso)`],
      ["3) Shoulder cover — cut 1x on fold",   `Cut half ${mm(g.backCover.cut.halfWidth)} × ${mm(g.backCover.cut.h)} mm at the centre, ${mm(g.backCover.cut.edgeH)} mm at the edge`],
      ["4) Side panel — cut 2x",               `Cut ${mm(g.side.cut.w)} × ${mm(g.side.cut.h)} mm · finished ${mm(g.side.w)} × ${mm(g.side.h)} mm`],
      ["5) Bottom panel — cut 1x",             `Cut ${mm(g.bottom.cut.w)} × ${mm(g.bottom.cut.h)} mm · finished ${mm(g.bottom.w)} × ${mm(g.bottom.h)} mm`],
      ["6) Front mesh pocket — no pattern piece", `Finished top ${mm(params.FP)} mm above the panel bottom · cut ${mm(MESH_CASING)} mm higher for the casing`],
      ["7) Side mesh pockets — no pattern piece", `Finished top ${mm(params.SPfront)} mm front / ${mm(params.SPback)} mm back · cut ${mm(MESH_CASING)} mm higher`],
    ];
    let cy = 50;
    cl.forEach(([title, dim]) => {
      pdf.setFont("helvetica","bold"); pdf.text(title, M, cy);
      pdf.setFont("helvetica","normal"); pdf.setTextColor(60); pdf.text(`   ${dim}`, M, cy+7); pdf.setTextColor(0);
      cy += 18;
    });
    footerCenter("friluftstyger.se · Make Your Own Gear");

    /* ---- PRINTING ---- */
    pdf.addPage();
    header("PRINTING","A4 tiling instructions");
    pdf.setFont("helvetica","normal"); pdf.setFontSize(10);
    const steps = [
      "1) Print at 100% scale (do not 'fit to page').",
      "2) Measure the 50 × 50 mm scale test box below before cutting anything.",
      `3) Tiles overlap by ${mm(OVERLAP)} mm. The grey dashed line marks the overlap:`,
      `     trim along it, or lay the next sheet on top so the lines meet.`,
      "4) Line up the corner registration marks, then tape.",
      "5) Tile numbering is Row / Col — assemble row by row.",
      "6) Cut on the solid line. Sew on the dashed line.",
      `7) Seam allowance is ${mm(params.Seam)} mm and is already included. The fold edge has none.`,
      "8) Mesh pockets have no piece — cut them to the solid orange line."
    ];
    let py = 50;
    steps.forEach(function (t) { pdf.text(t, M, py); py += 8; });
    scaleBox50(M, PAGE_H-68);
    footerCenter("friluftstyger.se · Make Your Own Gear");

    /* ---- INSTRUCTIONS ----
       Two columns that flow onto as many pages as the content needs. The old
       layout was a single fixed page and silently ran off the bottom. ---- */
    const COL1_X = M, COL2_X = PAGE_W/2 + 4, COL_W = PAGE_W/2 - M - 4;
    const TOP_Y = 40, BOT_Y = PAGE_H - 22;
    let colX = COL1_X, iy = TOP_Y;

    function newInstrPage() {
      pdf.addPage();
      header("INSTRUCTIONS", "Sewing guide");
      footerCenter("friluftstyger.se · Make Your Own Gear");
      colX = COL1_X; iy = TOP_Y;
    }
    function need(h) {
      if (iy + h <= BOT_Y) return;
      if (colX === COL1_X) { colX = COL2_X; iy = TOP_Y; }
      else newInstrPage();
    }
    function sHead(text) {
      need(16);
      pdf.setFillColor(...YELLOW); pdf.setLineWidth(0);
      pdf.rect(colX, iy - 4.5, COL_W, 7.5, "F");
      pdf.setFont("helvetica","bold"); pdf.setFontSize(9); pdf.setTextColor(0);
      pdf.text(text, colX + 3, iy + 1.5); iy += 10;
    }
    function step(letter, text) {
      pdf.setFont("helvetica","normal"); pdf.setFontSize(8.5);
      const lines = pdf.splitTextToSize(text, COL_W - 11);
      need(lines.length * 4.6 + 2);
      pdf.setFont("helvetica","bold"); pdf.setTextColor(44,95,45);
      pdf.text(letter, colX + 1, iy);
      pdf.setFont("helvetica","normal"); pdf.setTextColor(40);
      pdf.text(lines, colX + 8, iy);
      iy += lines.length * 4.6 + 1.5;
    }
    function note(text) {
      pdf.setFont("helvetica","italic"); pdf.setFontSize(7.8); pdf.setTextColor(110);
      const lines = pdf.splitTextToSize(text, COL_W - 4);
      need(lines.length * 4.2 + 2);
      pdf.text(lines, colX + 2, iy);
      pdf.setFont("helvetica","normal"); pdf.setTextColor(0);
      iy += lines.length * 4.2 + 2.5;
    }
    function gap() { iy += 4; }

    newInstrPage();

    sHead("BEFORE YOU START");
    step("1", "Print at 100% and check the 50 x 50 mm box. If it is wrong, nothing else will fit.");
    step("2", `Seam allowance is ${mm(params.Seam)} mm and is already included. Cut on the solid line, sew on the dashed line. The fold edge has no allowance.`);
    step("3", "Mark every hardware position on the RIGHT side of the fabric before you sew anything. Most of them get covered later.");
    note("Wonder tape (double-sided basting tape) is used throughout instead of pins. Slippery technical fabrics do not hold a pin line.");
    gap();

    sHead("FRONT PANEL");
    step("A", "Sew a foldable elastic along the top edge of the mesh, with the mesh sitting inside the fold of the elastic. Use a wide zigzag with a long stitch length.");
    step("B", "Fold the elastic edge inwards so the raw end is hidden. Bartack the centre to hold the fold: zigzag 4 mm wide, 0.5 mm stitch length or the shortest your machine allows.");
    step("C", `Tape the mesh to the lower part of the front panel with wonder tape, lining its top edge up with the mesh line at ${mm(params.FP)} mm. Sew the sides and bottom with a straight stitch.`);
    step("D", "Sew the Y-strap webbing to the centre of the panel, 40 mm above the mesh opening, on the fold line.");
    step("E", `Sew the chock cord loops in 10 mm webbing: three up each side at ${mm(T4.loopH[0])}, ${mm(T4.loopH[1])} and ${mm(T4.loopH[2])} mm, one centred on the bottom seam, and the ice axe loops 30 mm in from each bottom corner.`);
    note("The ice axe loops double as the lower attachment for trekking poles. A chock cord loop at the top hooks into one of the three side loops to hold the upper end.");
    gap();

    sHead("BACK PANEL");
    step("A", "Mark the shoulder line and both strap positions on the right side of the fabric.");
    step("B", "Sew the carry handle webbing 80 mm apart, just below the shoulder line — the pattern shows one bartack 40 mm from the fold, so the pair straddles the centre. Sew both ends of the Y-strap in the same pass.");
    step("C", `Sew the shoulder straps at the marked line, then the lower ends directly above the bottom seam. Webbing width is ${mm(params.StrapW)} mm.`);
    step("D", "Sew the bladder hang loop on the fold line, just below the carry handle.");
    step("E", "Fold the edges of the cover piece in and hold them with wonder tape. Clip the corners where the angle changes so the fold lies flat. Tape the folded edge down and sew the cover over the back panel so it hides the upper strap attachment, the handle and the Y-strap ends.");
    note(`The cover is ${mm(COVER_H)} mm tall at the centre and ${mm(g.backCover.edgeH)} mm at the edge with the current angle of ${mm(params.ShoulderAngle)} degrees.`);
    gap();

    sHead("SIDE PANELS");
    step("A", `Fold a double hem along the top of the pocket, ${mm(CORD_CHANNEL)} mm twice, and lay the chock cord inside it. Fold the corners in as small triangles so the cord runs freely. Straight stitch across the hem.`);
    step("B", `Fold the extra ${mm(POCKET_VOLUME/2)} mm at each bottom corner of the pocket into a pleat — that is what gives the pocket its volume. Tape the pocket to the lower part of the side panel with the SHORT edge against the back, then straight stitch the sides and bottom.`);
    step("C", "Sew a small loop of 10 mm webbing at the tall edge of the pocket for one end of the chock cord. Put a cord lock on the other end.");
    step("D", `Sew the side compression straps at ${mm(T4.compH[0])} and ${mm(T4.compH[1])} mm above the finished bottom. Two per side, four in total.`);
    step("E", `Sew the rolltop strap in one of the two marked positions: centred on the bottom seam, or standing on the back edge ${mm(ROLLTOP_STRAP)} mm up.`);
    gap();

    sHead("INNER DIVIDER POCKET (OPTIONAL)");
    step("A", `Hem the top edge of the divider piece, then sew it inside the bag along the sides and bottom. It is ${mm(BLADDER_H)} mm tall and its sides taper with the back panel.`);
    step("B", "A 3 L bladder is around 410 mm tall, so it will not stand in this pocket. Hang it from the loop on the back panel and let the divider hold the bottom.");
    note("Add a vertical seam or two if you want more compartments — the pattern gives you one as a base.");
    gap();

    sHead("ASSEMBLY");
    step("1", "Sew the two side panels to the left and right edges of the bottom panel.");
    step("2", `The front ${mm(BOTTOM_WRAP)} mm of the bottom panel turns up the front, so the front panel is ${mm(BOTTOM_WRAP)} mm shorter than the back. Sew the front panel to that turned-up edge.`);
    step("3", "Sew the front and back panels to the side panels. Work from the bottom up so the bottom corners stay square.");
    step("4", `Roll the top down two or three times, pull the Y-strap over the roll and close the front buckle. The roll allowance is ${mm(ROLLTOP)} mm.`);
    gap();

    sHead("RECOMMENDED MATERIALS");
    function matRow(lbl, desc, url) {
      pdf.setFont("helvetica","normal"); pdf.setFontSize(8);
      const lines = pdf.splitTextToSize(desc, COL_W - 9);
      need(lines.length * 4.5 + 8);
      pdf.setFont("helvetica","bold"); pdf.setFontSize(8.5); pdf.setTextColor(0);
      pdf.text("•", colX + 2, iy); pdf.text(lbl, colX + 7, iy);
      const lw = pdf.getTextWidth(lbl);
      pdf.setFont("helvetica","normal"); pdf.setFontSize(7.5); pdf.setTextColor(44,95,45);
      pdf.textWithLink(" -> shop", colX + 7 + lw, iy, { url });
      iy += 4.5;
      pdf.setFont("helvetica","normal"); pdf.setFontSize(8); pdf.setTextColor(80);
      pdf.text(lines, colX + 7, iy); pdf.setTextColor(0);
      iy += lines.length * 4.5 + 2;
    }
    matRow("Main fabric", "ULTRA 200X or EPX 200 — both 147-150 cm wide, sold per half metre.",
      "https://www.friluftstyger.se/collections/tyger");
    matRow("Side pockets", "ULTRA grid, Ultra Stretch or stretch mesh — your choice of stiffness.",
      "https://www.friluftstyger.se/collections/tyger");
    matRow("Front mesh", "Stretch mesh or Ultra Stretch.",
      "https://www.friluftstyger.se/collections/tyger");
    matRow("Webbing", "20 mm for the Y-strap and compression, 10 mm for the loops.",
      "https://www.friluftstyger.se/collections/band");
    matRow("Hardware", "Side release buckles, cord locks, chock cord, foldable elastic.",
      "https://www.friluftstyger.se/collections/spannen");


    /* ---- TILES ----
       Driven by the shared piece table, so the tiled pages and the copyshop
       sheet always show the same pieces with the same markings. ---- */
    const DR = makePieceDrawer(pdf, params, g, T4);
    T4.pieces.forEach(function (it) {
      addTiledPiece({
        pieceTitle: it.title + " — " + it.sub,
        subTitle:   pieceDims(it),
        w: it.bw, h: it.bh,
        drawWorld: function (wx, wy) { DR.drawBody(it, wx, wy); }
      });
    });


    return pdf.output("blob");
  }

  /* =========================
     ZIP download
  ========================== */
  function downloadZip(filename, files) {
    if (!window.JSZip) throw new Error("JSZip not loaded");
    const zip = new JSZip();
    for (const [name,data] of Object.entries(files)) zip.file(name,data);
    return zip.generateAsync({type:"blob"}).then(blob => {
      const url=URL.createObjectURL(blob);
      const a=document.createElement("a"); a.href=url; a.download=filename;
      document.body.appendChild(a); a.click(); a.remove(); URL.revokeObjectURL(url);
    });
  }

  /* =========================
     Button
  ========================== */
  if (btn) {
    btn.addEventListener("click", () => {
      btn.disabled=true; setStatus("Generating PDF + SVG files…");
      // Wait for the logo fetch so the cover page is complete on the first click too.
      logoReady.catch(()=>null).then(() => {
      try {
        const params=getParams();
        if (params.Wt<=0||params.Wb<=0||params.H<=0||params.D<=0) {
          setStatus("Please enter valid dimensions."); btn.disabled=false; return;
        }
        setStatus("Building PDF…");
        const pdfBlob=buildPDFBlob(params);
        setStatus("Building copyshop sheet…");
        const a0Blob=buildA0Blob(params);
        setStatus("Building SVGs…");
        const svgFiles=buildSVGStrings(params);
        setStatus("Creating ZIP…");
        downloadZip("Rolltop_Backpack_Pattern_Pack.zip", {
          "Rolltop_Backpack_Pattern_A4.pdf": pdfBlob,
          "Rolltop_Backpack_Copyshop_1to1.pdf": a0Blob,
          ...svgFiles
        })
          .then(() => {
            setStatus("Done! Your ZIP download should have started.");
            try {
              if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === "function") {
                Shopify.analytics.publish("friluftstyger:pattern_download", {
                  pattern:      "rolltop_backpack",
                  width_top:    params.Wt,
                  width_bottom: params.Wb,
                  height:       params.H,
                  depth:        params.D,
                  torso:        params.Torso,
                  rolltop:      params.RT,
                  seam:         params.Seam
                });
              }
            } catch(e){}
          })
          .catch(err => { console.error(err); setStatus("Something went wrong. Please reload and try again."); })
          .finally(() => { btn.disabled=false; });
      } catch(err) {
        console.error(err); setStatus("Something went wrong. Please reload and try again."); btn.disabled=false;
      }
      });
    });
  }

  /* =========================
     INIT
  ========================== */
  ensureMaterialUI();
  setupRanges();
  ensureHardwareUI();
  addHelpTo("rb_torso");
  ensureResetViewButton();
  resizeCanvas();
  ["rb_wt","rb_wb","rb_h","rb_d","rb_fp","rb_sp_front","rb_mat","rb_torso"].forEach(id => {
    const el=$(id); if(!el) return;
    el.addEventListener("input", requestDraw);
    el.addEventListener("change", requestDraw);
  });
  drawPreview();
}

// Run after DOM is ready (safe with defer — scripts execute in order after parsing)
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initRolltopBackpackGenerator);
} else {
  initRolltopBackpackGenerator();
}

// Also run when Shopify dynamically loads the section (theme editor / AJAX navigation)
document.addEventListener("shopify:section:load", function(e) {
  if (e.target && e.target.querySelector("#rolltop-backpack-generator")) {
    initRolltopBackpackGenerator();
  }
});